(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5778],{

/***/ 50381:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var deselectCurrent = __webpack_require__(91706);

var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
}

var defaultMessage = "Copy to clipboard: #{key}, Enter";

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
    message,
    reselectPrevious,
    range,
    selection,
    mark,
    success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement("span");
    mark.textContent = text;
    // avoid screen readers from reading out loud the text
    mark.ariaHidden = "true"
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function(e) {
      e.stopPropagation();
      if (options.format) {
        e.preventDefault();
        if (typeof e.clipboardData === "undefined") { // IE 11
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"]
          window.clipboardData.setData(format, text);
        } else { // all other browsers
          e.clipboardData.clearData();
          e.clipboardData.setData(options.format, text);
        }
      }
      if (options.onCopy) {
        e.preventDefault();
        options.onCopy(e.clipboardData);
      }
    });

    document.body.appendChild(mark);

    range.selectNodeContents(mark);
    selection.addRange(range);

    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

module.exports = copy;


/***/ }),

/***/ 19494:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/non-benefit/map",
      function () {
        return __webpack_require__(65282);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var Link = function(param) {
    var _hasWrapper = param.hasWrapper, hasWrapper = _hasWrapper === void 0 ? true : _hasWrapper;
    if (hasWrapper) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    width: "32",
                    height: "32",
                    rx: "16",
                    fill: "#DFE1E2"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    clipPath: "url(#clip0_187_4288)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M19.5458 8.00944C19.1947 8.0585 18.8648 8.20877 18.5967 8.4418C18.5587 8.47482 17.9873 9.04759 17.3268 9.71463C16.6664 10.3817 15.8477 11.2082 15.5076 11.5514C15.0912 11.9715 14.8781 12.1911 14.8553 12.2234C14.7984 12.3041 14.7632 12.3831 14.7383 12.4858C14.725 12.5409 14.7269 12.7264 14.7414 12.7883C14.7857 12.9771 14.9043 13.1363 15.0787 13.2411C15.1368 13.276 15.1781 13.293 15.2546 13.3134C15.2983 13.3251 15.3236 13.3271 15.4274 13.3272C15.5407 13.3273 15.5533 13.3261 15.613 13.3096C15.6929 13.2875 15.7767 13.2463 15.844 13.196C15.8794 13.1695 16.4653 12.5823 17.7064 11.3294C18.7022 10.324 19.5315 9.49052 19.5492 9.47714C19.6175 9.42552 19.6965 9.40048 19.7922 9.40013C19.8869 9.39978 19.9553 9.41897 20.0248 9.46542C20.0495 9.48188 20.4235 9.85676 21.1084 10.5514C22.6644 12.1296 22.49 11.9488 22.524 12.0193C22.5565 12.0868 22.5666 12.1313 22.5666 12.2076C22.5666 12.2727 22.549 12.3435 22.5177 12.4046C22.4954 12.4481 22.3941 12.5508 20.656 14.2906C19.0524 15.8959 18.8135 16.1376 18.7826 16.185C18.7391 16.2519 18.7195 16.291 18.7024 16.345C18.6753 16.4307 18.6722 16.4546 18.6724 16.5754C18.6726 16.6755 18.6747 16.7018 18.6862 16.745C18.7065 16.8213 18.7236 16.8628 18.7585 16.9209C18.8634 17.0954 19.0225 17.2139 19.2114 17.2582C19.25 17.2673 19.2857 17.2697 19.373 17.2693C19.4731 17.2688 19.4918 17.267 19.549 17.2517C19.6244 17.2316 19.7003 17.1965 19.7686 17.1504C19.8071 17.1243 20.202 16.7332 21.5928 15.3439C22.5691 14.3686 23.4076 13.5283 23.4561 13.4765C23.5582 13.3675 23.6081 13.3053 23.6755 13.2026C23.7995 13.0141 23.8908 12.7922 23.9356 12.5709C23.964 12.4304 23.9712 12.3567 23.9712 12.2042C23.9712 12.0518 23.964 11.9781 23.9356 11.8375C23.8775 11.5505 23.7472 11.2775 23.5576 11.0453C23.5253 11.0058 23.297 10.7687 23.0501 10.5185C22.8032 10.2682 22.2652 9.72215 21.8545 9.30503C21.4438 8.88791 21.0739 8.51544 21.0324 8.47733C20.752 8.21971 20.4091 8.05847 20.0358 8.00876C19.9457 7.99676 19.6334 7.99719 19.5458 8.00944ZM18.1666 13.0562C18.0995 13.0626 18.0112 13.0863 17.9525 13.1136C17.8344 13.1685 17.9689 13.0373 15.5035 15.5027C13.0379 17.9682 13.1691 17.8337 13.1143 17.9517C13.0386 18.1149 13.0334 18.3373 13.1014 18.5071C13.1696 18.6773 13.3223 18.83 13.4926 18.8982C13.6623 18.9662 13.8847 18.961 14.0479 18.8853C14.1659 18.8305 14.0314 18.9617 16.4969 16.4962C18.9625 14.0306 18.8312 14.1651 18.886 14.0471C18.9615 13.8844 18.9668 13.6611 18.899 13.4918C18.8436 13.3535 18.7321 13.2256 18.5951 13.1433C18.4791 13.0737 18.3206 13.0414 18.1666 13.0562ZM12.5378 14.7295C12.4066 14.752 12.3215 14.7859 12.2242 14.8545C12.1919 14.8773 11.9722 15.0905 11.5522 15.5068C11.209 15.847 10.3824 16.6657 9.71538 17.3261C9.04834 17.9865 8.47557 18.558 8.44255 18.596C8.20667 18.8674 8.05682 19.199 8.00951 19.5542C7.99683 19.6494 7.99683 19.9399 8.00951 20.035C8.05773 20.3971 8.21085 20.7307 8.45672 21.0095C8.55327 21.1189 10.9877 23.5456 11.053 23.5975C11.3264 23.8146 11.6305 23.9456 11.9646 23.9901C12.0598 24.0028 12.3502 24.0028 12.4454 23.9901C12.8169 23.9406 13.1621 23.7791 13.4389 23.525C13.4787 23.4885 14.0387 22.9258 14.6833 22.2746C15.3279 21.6234 16.1391 20.8041 16.4861 20.4538C16.9475 19.9881 17.126 19.8038 17.1507 19.7678C17.1969 19.7004 17.2321 19.6243 17.2525 19.5482C17.2677 19.491 17.2696 19.4723 17.2701 19.3722C17.2705 19.285 17.268 19.2493 17.2589 19.2106C17.2146 19.0217 17.0961 18.8626 16.9216 18.7577C16.8636 18.7229 16.8223 18.7059 16.7458 18.6854C16.7021 18.6737 16.6768 18.6717 16.573 18.6716C16.4595 18.6715 16.4471 18.6727 16.3874 18.6893C16.3061 18.7119 16.2225 18.7529 16.1563 18.8027C16.1213 18.829 15.5146 19.4371 14.2918 20.6716C13.2949 21.678 12.4653 22.5116 12.4484 22.5241C12.3789 22.5751 12.3022 22.5986 12.205 22.5986C12.1264 22.5986 12.081 22.5883 12.013 22.5551C11.9661 22.5323 11.9357 22.5024 10.7164 21.2832C9.49722 20.064 9.46735 20.0335 9.4445 19.9866C9.41133 19.9186 9.40106 19.8732 9.40106 19.7946C9.40106 19.6958 9.42539 19.6179 9.47791 19.5484C9.49129 19.5307 10.3248 18.7014 11.3302 17.7056C12.5825 16.4651 13.1703 15.8786 13.1968 15.8432C13.247 15.776 13.2883 15.6922 13.3104 15.6122C13.3269 15.5526 13.3281 15.54 13.328 15.4266C13.3279 15.3229 13.3259 15.2975 13.3142 15.2538C13.2938 15.1774 13.2768 15.136 13.2419 15.078C13.1382 14.9055 12.9811 14.7875 12.7938 14.7415C12.7538 14.7316 12.5743 14.7233 12.5378 14.7295Z",
                        fill: "#3D4551"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip0_187_4288",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "16",
                            height: "16",
                            fill: "white",
                            transform: "translate(8 8)"
                        })
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_403_8651)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.5458 0.00943519C11.1947 0.0584976 10.8648 0.20877 10.5967 0.4418C10.5587 0.474818 9.98728 1.04759 9.32685 1.71463C8.6664 2.38167 7.84774 3.20823 7.50758 3.55143C7.09124 3.9715 6.87805 4.19112 6.85526 4.22343C6.79836 4.3041 6.76318 4.38305 6.73834 4.48583C6.72501 4.54093 6.72691 4.72638 6.74143 4.78826C6.78574 4.97713 6.90426 5.13626 7.07874 5.24113C7.13678 5.27601 7.17811 5.29301 7.25458 5.31345C7.29828 5.32512 7.32361 5.32714 7.42738 5.32723C7.5407 5.32732 7.55334 5.32613 7.61298 5.30962C7.69294 5.2875 7.77675 5.24629 7.84396 5.19604C7.87945 5.16951 8.46528 4.58234 9.70636 3.3294C10.7022 2.32405 11.5315 1.49052 11.5492 1.47714C11.6175 1.42552 11.6965 1.40048 11.7922 1.40013C11.8869 1.39978 11.9553 1.41897 12.0248 1.46542C12.0495 1.48188 12.4235 1.85676 13.1084 2.55139C14.6644 4.12964 14.49 3.9488 14.524 4.01933C14.5565 4.08678 14.5666 4.13127 14.5666 4.20759C14.5666 4.27274 14.549 4.34346 14.5177 4.40455C14.4954 4.44812 14.3941 4.55078 12.656 6.29063C11.0524 7.89592 10.8135 8.13757 10.7826 8.18503C10.7391 8.25189 10.7195 8.29103 10.7024 8.34503C10.6753 8.43074 10.6722 8.45459 10.6724 8.57543C10.6726 8.67551 10.6747 8.70175 10.6862 8.74503C10.7065 8.82134 10.7236 8.86276 10.7585 8.92087C10.8634 9.09536 11.0225 9.21388 11.2114 9.25819C11.25 9.26726 11.2857 9.26972 11.373 9.26931C11.4731 9.26884 11.4918 9.26697 11.549 9.2517C11.6244 9.23159 11.7003 9.19653 11.7686 9.15036C11.8071 9.1243 12.202 8.73324 13.5928 7.34387C14.5691 6.36859 15.4076 5.52826 15.4561 5.47646C15.5582 5.36753 15.6081 5.30529 15.6755 5.20263C15.7995 5.01407 15.8908 4.79223 15.9356 4.57094C15.964 4.43041 15.9712 4.35669 15.9712 4.20423C15.9712 4.05178 15.964 3.97806 15.9356 3.83752C15.8775 3.55055 15.7472 3.27749 15.5576 3.04533C15.5253 3.00583 15.297 2.76874 15.0501 2.51847C14.8032 2.2682 14.2652 1.72215 13.8545 1.30503C13.4438 0.887912 13.0739 0.515445 13.0324 0.477326C12.752 0.219714 12.4091 0.058472 12.0358 0.00875679C11.9457 -0.00324321 11.6334 -0.00280801 11.5458 0.00943519ZM10.1666 5.05617C10.0995 5.06259 10.0112 5.08627 9.9525 5.11356C9.83439 5.16848 9.96887 5.03729 7.50346 7.50271C5.03792 9.96824 5.16913 9.83374 5.11435 9.95175C5.0386 10.1149 5.03341 10.3373 5.10139 10.5071C5.16957 10.6773 5.32228 10.83 5.49256 10.8982C5.66232 10.9662 5.88471 10.961 6.04787 10.8853C6.16587 10.8305 6.03137 10.9617 8.49691 8.49615C10.9625 6.03062 10.8312 6.16512 10.886 6.04712C10.9615 5.88443 10.9668 5.66108 10.899 5.49181C10.8436 5.35347 10.7321 5.22559 10.5951 5.14333C10.4791 5.07367 10.3206 5.04143 10.1666 5.05617ZM4.53778 6.72951C4.40655 6.75196 4.3215 6.78586 4.22418 6.85451C4.19187 6.8773 3.97225 7.09049 3.55218 7.50683C3.20898 7.84699 2.38242 8.66565 1.71538 9.32609C1.04834 9.98653 0.47557 10.558 0.442552 10.596C0.206674 10.8674 0.056824 11.199 0.0095088 11.5542C-0.0031696 11.6494 -0.0031696 11.9399 0.0095088 12.035C0.0577264 12.3971 0.210846 12.7307 0.456715 13.0095C0.553266 13.1189 2.98765 15.5456 3.05298 15.5975C3.32635 15.8146 3.63046 15.9456 3.96457 15.9901C4.05975 16.0028 4.35021 16.0028 4.44539 15.9901C4.81694 15.9406 5.16205 15.7791 5.43894 15.525C5.47873 15.4885 6.03868 14.9258 6.68327 14.2746C7.32785 13.6234 8.13913 12.8041 8.48611 12.4538C8.94747 11.9881 9.12604 11.8038 9.15068 11.7678C9.19689 11.7004 9.23215 11.6243 9.25245 11.5482C9.26772 11.491 9.26959 11.4723 9.27006 11.3722C9.27047 11.285 9.26801 11.2493 9.25894 11.2106C9.21463 11.0217 9.09611 10.8626 8.92162 10.7577C8.86359 10.7229 8.82226 10.7059 8.74578 10.6854C8.70209 10.6737 8.67676 10.6717 8.57298 10.6716C8.45953 10.6715 8.4471 10.6727 8.38738 10.6893C8.30606 10.7119 8.22246 10.7529 8.15631 10.8027C8.1213 10.829 7.51458 11.4371 6.29181 12.6716C5.29488 13.678 4.46534 14.5116 4.44838 14.5241C4.37889 14.5751 4.30222 14.5986 4.20498 14.5986C4.12642 14.5986 4.08101 14.5883 4.01298 14.5551C3.96611 14.5323 3.93566 14.5024 2.71644 13.2832C1.49722 12.064 1.46735 12.0335 1.4445 11.9866C1.41133 11.9186 1.40106 11.8732 1.40106 11.7946C1.40106 11.6958 1.42539 11.6179 1.47791 11.5484C1.49129 11.5307 2.32482 10.7014 3.33019 9.70558C4.58253 8.46508 5.1703 7.87864 5.19681 7.84318C5.24704 7.776 5.28825 7.69217 5.31037 7.61223C5.32688 7.55259 5.32807 7.53995 5.32798 7.42663C5.3279 7.32286 5.32587 7.29752 5.3142 7.25383C5.29376 7.17736 5.27676 7.13603 5.24188 7.07799C5.1382 6.90548 4.98114 6.78753 4.79378 6.74148C4.75379 6.73165 4.57433 6.72326 4.53778 6.72951Z",
                    fill: "#3D4551"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_403_8651",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Link);


/***/ }),

/***/ 45587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ KAKAO_SHARE_TYPE; },
  "C": function() { return /* binding */ share_select_modal; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-copy-to-clipboard/lib/index.js
var lib = __webpack_require__(72282);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./src/components/atom/icon/Kakao.tsx

var KakaoIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "16",
                fill: "#FFE337"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.6719 10C14.7552 10 13.8906 10.1406 13.0781 10.4219C12.2656 10.7031 11.5573 11.0833 10.9531 11.5625C10.349 12.0417 9.86979 12.6042 9.51562 13.25C9.17188 13.8958 9 14.5833 9 15.3125C9 15.7812 9.07292 16.2344 9.21875 16.6719C9.36458 17.099 9.56771 17.5052 9.82812 17.8906C10.099 18.2656 10.4219 18.6146 10.7969 18.9375C11.1719 19.25 11.5833 19.526 12.0312 19.7656L11.5312 22.375L14.4219 20.5312C14.6198 20.5625 14.8229 20.5885 15.0312 20.6094C15.2396 20.6198 15.4531 20.625 15.6719 20.625C16.5885 20.625 17.4531 20.4896 18.2656 20.2188C19.0781 19.9375 19.7865 19.5573 20.3906 19.0781C20.9948 18.5885 21.4688 18.026 21.8125 17.3906C22.1667 16.7448 22.3438 16.0521 22.3438 15.3125C22.3438 14.5833 22.1667 13.8958 21.8125 13.25C21.4688 12.6042 20.9948 12.0417 20.3906 11.5625C19.7865 11.0833 19.0781 10.7031 18.2656 10.4219C17.4531 10.1406 16.5885 10 15.6719 10Z",
                fill: "black"
            })
        ]
    });
};
/* harmony default export */ var Kakao = (KakaoIcon);

// EXTERNAL MODULE: ./src/components/atom/icon/Link.tsx
var Link = __webpack_require__(2721);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
// EXTERNAL MODULE: ../../libs/ui/dist/index.es.js
var index_es = __webpack_require__(4601);
// EXTERNAL MODULE: ./src/components/molecules/modal/select-modal/index.tsx
var select_modal = __webpack_require__(15222);
;// CONCATENATED MODULE: ./src/components/molecules/modal/select-modal/share-select-modal/index.tsx










var KAKAO_SHARE_TYPE = {
    QNA: "QNA",
    MAGAZINE: "MAGAZINE",
    BOARD_POST: "BOARD_POST",
    NON_BENEFIT_MAP: "NON_BENEFIT_MAP"
};
/**
 * @param isVisible boolean
 * @param onClose () => void
 * @param type KAKAO_SHARE_TYPE
 * @param pageName string
 * @param kakaoShare [optional] KakaoShareProps
 * @param copyLink? CopyLinkProps
 */ var ShareSelectModal = function(param) {
    var isVisible = param.isVisible, onClose = param.onClose, type = param.type, pageName = param.pageName, kakaoShare = param.kakaoShare, copyLink = param.copyLink;
    var toast = (0,index_es/* useToast */.pm)().toast;
    var ref = (0,react.useState)(false), _isVisible = ref[0], _setIsVisible = ref[1];
    var ref1 = (0,react.useState)(), shareItems = ref1[0], setShareItems = ref1[1];
    var eventNamePath = type.toLocaleLowerCase();
    // 공유하기 [카카오]
    var onShareKakao = (0,react.useCallback)(function() {
        if (!window.Kakao.isInitialized()) {
            window.Kakao.init("b921b0231b604bf1aea6460c3d26cb57");
        }
        if (kakaoShare) {
            (0,logger/* mobileLogger */.Pp)({
                logger: {
                    eventName: "".concat(eventNamePath, "_share_kakao_click"),
                    pageName: pageName,
                    payload: {
                        id: kakaoShare.id
                    }
                }
            });
            var Kakao = window.Kakao;
            if (type === KAKAO_SHARE_TYPE.QNA) {
                Kakao.Share.sendCustom({
                    templateId: 90853,
                    templateArgs: {
                        questionPid: kakaoShare.id,
                        title: kakaoShare.title,
                        content: kakaoShare.content
                    }
                });
            }
            if (type === KAKAO_SHARE_TYPE.MAGAZINE) {
                Kakao.Share.sendCustom({
                    templateId: 90880,
                    templateArgs: {
                        magazinePid: kakaoShare.id,
                        title: kakaoShare.title,
                        description: kakaoShare.content,
                        titleImageUrl: kakaoShare.imageUrl
                    }
                });
            }
            if (type === KAKAO_SHARE_TYPE.BOARD_POST) {
                Kakao.Share.sendCustom({
                    templateId: 94245,
                    templateArgs: {
                        id: kakaoShare.id,
                        title: kakaoShare.title,
                        content: kakaoShare.content
                    }
                });
            }
            if (type === KAKAO_SHARE_TYPE.NON_BENEFIT_MAP) {
                Kakao.Share.sendCustom({
                    templateId: 114723,
                    templateArgs: {
                        diagnosisTypeId: kakaoShare.id,
                        treatmentMedicineId: kakaoShare.subId,
                        title: kakaoShare.title,
                        description: kakaoShare.content,
                        thumbnailUrl: kakaoShare.imageUrl
                    }
                });
            }
        }
        onClose();
    }, [
        type,
        kakaoShare,
        eventNamePath,
        pageName,
        onClose
    ]);
    // 공유하기 [링크복사]
    var onCopyLink = (0,react.useCallback)(function() {
        if (copyLink) {
            var ref;
            (0,logger/* mobileLogger */.Pp)({
                logger: {
                    eventName: "".concat(eventNamePath, "_copy_link_click"),
                    pageName: pageName,
                    payload: {
                        id: copyLink === null || copyLink === void 0 ? void 0 : copyLink.id
                    }
                }
            });
            (ref = document.getElementById(copyLink === null || copyLink === void 0 ? void 0 : copyLink.copyElementId)) === null || ref === void 0 ? void 0 : ref.click();
        }
        onClose();
    }, [
        copyLink,
        eventNamePath,
        pageName,
        onClose
    ]);
    var onCompleteCopy = function() {
        toast({
            text: "클립보드로 복사되었습니다.",
            direction: "bottom"
        });
    };
    var generateSelectList = (0,react.useCallback)(function() {
        var selectItems = [];
        if (copyLink) {
            selectItems = [
                {
                    Icon: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            hasWrapper: true
                        });
                    },
                    text: "링크 복사",
                    onClick: onCopyLink
                }, 
            ].concat((0,_to_consumable_array/* default */.Z)(selectItems));
        }
        if (kakaoShare) {
            selectItems = [
                {
                    Icon: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Kakao, {});
                    },
                    text: "카카오톡으로 공유",
                    onClick: onShareKakao
                }, 
            ].concat((0,_to_consumable_array/* default */.Z)(selectItems));
        }
        setShareItems(selectItems);
    }, [
        copyLink,
        onShareKakao,
        onCopyLink,
        kakaoShare,
        setShareItems
    ]);
    (0,react.useEffect)(function() {
        generateSelectList();
    }, [
        generateSelectList
    ]);
    (0,react.useEffect)(function() {
        _setIsVisible(isVisible);
    }, [
        isVisible
    ]);
    // https://sharer.kakao.com/picker/link?app_key=b921b0231b604bf1aea6460c3d26cb57&short_key=7007dc80-2f45-494f-a8fc-3ad2b18dd522
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    defer: true,
                    src: "https://developers.kakao.com/sdk/js/kakao.min.js"
                })
            }),
            _isVisible && !!shareItems && /*#__PURE__*/ (0,jsx_runtime.jsx)(select_modal/* default */.Z, {
                modalTitle: "공유하기",
                selectList: shareItems,
                onClose: onClose
            }),
            !!copyLink && /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                text: copyLink.copyLinkUrl,
                onCopy: onCompleteCopy,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    id: copyLink.copyElementId
                })
            })
        ]
    });
};
/* harmony default export */ var share_select_modal = (ShareSelectModal);


/***/ }),

/***/ 28265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ BreadCrumbsWrapper; },
  "Z": function() { return /* binding */ faq_tag_list_template; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/atom/BreadCrumbs.tsx
var BreadCrumbs = __webpack_require__(27441);
// EXTERNAL MODULE: ./src/components/common/communication/magazine/ListMagazineLine.tsx + 2 modules
var ListMagazineLine = __webpack_require__(79476);
// EXTERNAL MODULE: ./src/components/common/link-tag/index.tsx
var link_tag = __webpack_require__(1967);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/components/molecules/sticky-app-header/index.tsx + 3 modules
var sticky_app_header = __webpack_require__(83025);
// EXTERNAL MODULE: ./src/components/templates/mobile/communication/magazine/magazine-mobile-template/magazine-skeleton/index.tsx
var magazine_skeleton = __webpack_require__(62405);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./src/hooks/magazine/magazine.gql.impl.tsx
var magazine_gql_impl = __webpack_require__(44355);
// EXTERNAL MODULE: ./src/types/magazine.ts
var magazine = __webpack_require__(45162);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./src/hooks/faq/useGetFaqTagListPage.ts





var parseMagazineTagList = function(data) {
    var parseMagazineListItem = function(magazine) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, magazine), {
            magazinePid: magazine.magazinePid,
            date: "".concat(dayjs_min_default()(magazine.createdAt).format("YYYY.MM.DD"))
        });
    };
    if (data) {
        return data.tagMagazineCursorPage.elements.map(function(magazine) {
            return parseMagazineListItem(magazine);
        });
    }
    return [];
};
var useGetFaqTagListPage = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 20, tagName = arguments.length > 1 ? arguments[1] : void 0;
    var ref = (0,magazine_gql_impl/* useGetMagazineTagListPageQuery */.wJ)({
        request: {
            size: size,
            tagName: tagName,
            contentType: magazine/* MagazineType.FAQ */.rL.FAQ
        }
    }, {
        select: function(data) {
            return parseMagazineTagList(data);
        }
    }), faqs = ref.data, faqsLoading = ref.isLoading;
    return {
        faqs: faqs !== null && faqs !== void 0 ? faqs : [],
        faqsLoading: faqsLoading
    };
};
/* harmony default export */ var faq_useGetFaqTagListPage = (useGetFaqTagListPage);

// EXTERNAL MODULE: ./src/hooks/useCustomRouter.tsx
var useCustomRouter = __webpack_require__(77196);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
;// CONCATENATED MODULE: ./src/hooks/faq/useFaqTagViewModel.ts



var useFaqTagViewModel = function(tag) {
    var ref = faq_useGetFaqTagListPage(20, tag), faqs = ref.faqs, faqsLoading = ref.faqsLoading;
    var moveToPage = (0,useCustomRouter/* default */.Z)().moveToPage;
    var onClickMove = function(faqPid) {
        moveToPage({
            webLink: "".concat(common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(faqPid),
            mobileScreenName: common/* ROUTES.FAQ.DETAIL.appScreenName */.Z6.FAQ.DETAIL.appScreenName,
            params: {
                id: faqPid
            }
        });
    };
    return {
        faqs: faqs,
        faqsLoading: faqsLoading,
        onClickMove: onClickMove
    };
};
/* harmony default export */ var faq_useFaqTagViewModel = (useFaqTagViewModel);

// EXTERNAL MODULE: ./src/styles/layout.ts
var layout = __webpack_require__(64952);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
;// CONCATENATED MODULE: ./src/components/templates/communication/faq/faq-tag-list-template/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  background-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding-bottom: 16px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  max-width: 1152px;\n  flex-direction: column;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 24px 8px 24px;\n  color: ",
        ";\n  ",
        ";\n\n  @media screen and (max-width: ",
        ") {\n    ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}














var FaqTagListTemplate = function(param) {
    var tag = param.tag, client = param.client;
    var viewModel = faq_useFaqTagViewModel(tag);
    if (viewModel.faqsLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(magazine_skeleton/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            client.isWebView && /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.Header */.Z.Header, {
                useSafeArea: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sticky_app_header/* default */.Z, {
                    title: "1분 FAQ"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                children: [
                    client.clientType === app/* ClientType.WEB */.B.WEB && /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                            visible: true,
                            path: "".concat(common/* ROUTES.FAQ.TAG.path */.Z6.FAQ.TAG.path),
                            type: "magazine"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTile, {
                                children: "#".concat(tag)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: viewModel.faqs.map(function(faq) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(link_tag/* default */.Z, {
                                        href: "".concat(common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(faq.magazinePid),
                                        onClickNavigateToScreen: function() {
                                            return viewModel.onClickMove(faq.magazinePid);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListMagazineLine/* default */.Z, {
                                            magazine: {
                                                title: faq.title,
                                                mobileTitle: faq.mobileTitle,
                                                image: "",
                                                date: faq.date,
                                                magazinePid: faq.magazinePid,
                                                description: faq.description,
                                                mobileDescription: faq.mobileDescription,
                                                siteName: ""
                                            }
                                        })
                                    }, faq.magazinePid);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var faq_tag_list_template = (FaqTagListTemplate);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5743a130-0"
})(_templateObject(), function(param) {
    var _$theme = param.theme;
    return _$theme.color.white;
});
var BreadCrumbsWrapper = (0,styled_components_browser_esm/* default */.ZP)(BreadCrumbs/* default.Wrapper */.Z.Wrapper).withConfig({
    componentId: "sc-5743a130-1"
})(_templateObject1(), function(param) {
    var _$theme = param.theme;
    return _$theme.color.white;
});
var Content = styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
    componentId: "sc-5743a130-2"
})(_templateObject2());
var PageTile = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-5743a130-3"
})(_templateObject3(), theme/* default.color.gray700 */.Z.color.gray700, theme/* default.typography.UI28SB */.Z.typography.UI28SB, layout/* Tablet */.YD, theme/* default.typography.UI22SB */.Z.typography.UI22SB);


/***/ }),

/***/ 62405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89961);
/* harmony import */ var _components_atom_skeleton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46799);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px;\n  display: flex;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: calc(100% - 96px);\n  margin-right: 20px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var MagazineItemSkeleton = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Left, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Row, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                style: {
                                    width: 60,
                                    height: 18,
                                    marginRight: 8
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                style: {
                                    width: 66,
                                    height: 18
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        style: {
                            height: 48,
                            marginTop: 8,
                            marginBottom: 4
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        style: {
                            height: 18,
                            marginBottom: 2
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        style: {
                            width: "70%",
                            height: 18
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Right, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        style: {
                            width: 96,
                            height: 72,
                            marginBottom: 4
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        style: {
                            width: 96,
                            height: 28
                        }
                    })
                ]
            })
        ]
    });
};
var MagazineSkeleton = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        children: Array.from({
            length: 8
        }).map(function(_, i) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MagazineItemSkeleton, {}, "skeleton_".concat(i));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MagazineSkeleton);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-158fb6bb-0"
})(_templateObject());
var Left = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-158fb6bb-1"
})(_templateObject1());
var Row = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-158fb6bb-2"
})(_templateObject2());
var Right = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-158fb6bb-3"
})(_templateObject3());


/***/ }),

/***/ 53199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ui_MedicineInfoBottomSheet; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/components/molecules/overlay/index.tsx + 1 modules
var overlay = __webpack_require__(48785);
;// CONCATENATED MODULE: ./src/constants/pharmacy/index.ts
var finasterides = [
    "프로스카정",
    "프로페시아정",
    "피나스타정",
    "알파스카정",
    "프로피나정",
    "프로스몰정",
    "피나이스정",
    "한올피나스테리드정",
    "스카렉스정",
    "피나로신정",
    "피나드론정",
    "스카테론정",
    "유로리드정",
    "프로엠정",
    "대웅바이오피나스테리드정",
    "핀카정",
    "유로피나정",
    "피나베린정",
    "피로이드정",
    "푸로스타정",
    "프로리드정",
    "피나스텔정",
    "피나스티드정",
    "파나스카정",
    "리드페시아정",
    "트로피나정",
    "파나드정",
    "보령피나스테리드정",
    "일양피나스테리드정",
    "유로스칸정",
    "피스테리정",
    "푸로케어정",
    "피나테드정",
    "파세드정",
    "한림피나스테리드정",
    "알로시아정",
    "피나스틴정",
    "모나스타정",
    "알로페시드정",
    "헤어페시아정",
    "헤어피나정",
    "피나모린정",
    "레나시딘정",
    "바로피나정",
    "발트만정",
    "미노페시아정",
    "네오페시아정",
    "마이시아정",
    "다모케어정",
    "메디페시아정",
    "알로게인정",
    "그로모정",
    "모나리드정",
    "모나스틴정",
    "두피나정",
    "피나페시아정",
    "케이시아정",
    "피나시딜정",
    "모나드정",
    "헤나모정",
    "페로시아정",
    "헤어게인정",
    "다모페시아정",
    "헤어스모정",
    "알로펙정",
    "알로스칸정",
    "뉴피나정",
    "마이페시아정",
    "하이페시아정",
    "베아리모정",
    "프로시정",
    "마인페시아정",
    "헤어그로정",
    "유나피아정",
    "유나시아정",
    "모나필정",
    "피나젠정",
    "프리스타정",
    "피나트라정",
    "핀스타정",
    "피나라이드정",
    "화이자피나스테리드정",
    "피나세틴정",
    "필라스트정",
    "나우스카정",
    "프리피나정",
    "파나리드정",
    "프로스테리드정",
    "피나시아정",
    "피나그렌정",
    "피나린정",
    "프로스타트정",
    "마이피나정",
    "메리나정",
    "피나프로스정",
    "피나텐정",
    "피나스토정",
    "에피나시정",
    "씨엠피나정",
    "씨엠프로정",
    "피나스칸정",
    "피나드정",
    "피나정",
    "모나정",
    "모더페시아정",
    "비피케어정",
    "피나스로정",
    "티나제정",
    "프로스틸정",
    "모페시아정",
    "베르모나정",
    "엔피스카정",
    "피나스테아정",
    "피나진정",
    "피테스정",
    "피나롤정",
    "프로나드정",
    "하이피나정",
    "유레이드정",
    "피나에이블정",
    "비보존피나스테리드정",
    "피나즈정",
    "알로피나정",
    "피나론정",
    "모나페시아정",
    "스텐카정",
    "이노엔피나스테리드정",
    "삼성피나스테리드정",
    "피나스트리온정",
    "모나시아정",
    "큐로이드정",
    "프로화정",
    "모리턴정",
    "신신피나스테리드정",
    "피나스정",
    "피나윈정",
    "리모날정",
    "엔피나정",
    "다림피나스테리드정",
    "모어에이블정",
    "피나스톤정",
    "피나테크정",
    "피나스테린정",
    "피나세타정",
    "유니테리드정",
    "모그로정",
    "프로모아정",
    "피노테정",
    "알파엠정",
    "포뮬레시아정",
    "제이페시아정",
    "제이피나정",
    "모모페시아정",
    "피나리정",
    "피나디드정",
    "에이페시아정",
    "피나프로정",
    "뉴리드정",
    "위피나정",
    "멕스페시아정",
    "피나온정",
    "피나세트정",
    "테라피나스정",
    "명문피나스테리드정",
    "뉴페시아정",
    "피나에스정",
    "피나모아정",
    "프로핀카정",
    "한국팜비오피나스테리드정",
    "피나스트정",
    "아스테리정",
    "헤오나정",
    "피나앤정",
    "휴피나정",
    "피나신정",
    "텔콘알에프피나스테리드정",
    "스테리정",
    "프로아모정",
    "다모테리드정",
    "비피스타정",
    "메가페시아정",
    "엔티테리드정",
    "피나스텐정",
    "소피나정",
    "피나시드정",
    "안국피나스테리드정",
    "뉴모나스테리드정",
    "모벤시아정",
    "모모드정",
    "피나엠정",
    "다나페시아정",
    "모시아모정",
    "알로테드정",
    "와이투피나정",
    "그로페시아정",
    "피나모정",
    "제노페시아정",
    "오뉴페시아정",
    "원페시아정", 
];
var liraglutides = [
    "빅토자펜주",
    "삭센다펜주",
    "줄토피플렉스터치주"
];
var isotretinoins = [
    "아키놀연질캡슐",
    "니메겐연질캡슐",
    "핀플연질캡슐",
    "이소틴연질캡슐",
    "뉴티논연질캡슐",
    "이소티나연질캡슐",
    "이소트렌연질캡슐",
    "아크날연질캡슐",
    "트레틴연질캡슐",
    "아큐네탄연질캡슐",
    "이소티논연질캡슐",
    "이소트레틴겔",
    "레씨범연질캡슐",
    "트레인연질캡슐",
    "제로큐탄연질캡슐",
    "로아큐탄캡슐",
    "트레논연질캡슐",
    "로이탄연질캡슐",
    "오피큐탄연질캡슐",
    "아크논연질캡슐",
    "이소탐연질캡슐",
    "우리큐탄연질캡슐",
    "클레어연질캡슐",
    "삼성이소트레티노인연질캡슐",
    "이소팩트연질캡슐",
    "로아크연질캡슐",
    "화이트이소트레티노인연질캡슐",
    "로큐탄연질캡슐",
    "레아큐연질캡슐",
    "안국이소트레티노인연질캡슐",
    "모아큐탄연질캡슐", 
];
var clindamycins = [
    "듀케이겔",
    "에피외용액",
    "아클리신액",
    "아크닌액",
    "다크린외용액",
    "크리신외용액",
    "듀오크린액",
    "아크프리외용액",
    "크레오신티외용액1％",
    "퓨어킨외용액",
    "아크네신액",
    "클린티외용액",
    "에이치피앤씨클린다마이신포스페이트외용액1%",
    "클린다-케이외용액",
    "클린디올액",
    "끌로이외용액",
    "클린다미액",
    "피에이큐라덤외용액",
    "동인에피겔",
    "진다클린겔",
    "큐티안겔",
    "클린디올겔",
    "크레오신질크림2%",
    "듀악겔",
    "듀악겔5%",
    "듀악겔3%",
    "클리스코주",
    "크레오신주",
    "클리마이신주",
    "훌그램주사", 
];
var dutasterides = [
    "아보다트연질캡슐",
    "유힐릭스연질캡슐",
    "두타반연질캡슐",
    "두타론연질캡슐",
    "두테스몰연질캡슐",
    "아보스타연질캡슐",
    "아보테리드연질캡슐",
    "아나딘연질캡슐",
    "네오다트연질캡슐",
    "두테드연질캡슐",
    "씨엠두타연질캡슐",
    "두타리드연질캡슐",
    "아보피나연질캡슐",
    "두타텍트연질캡슐",
    "두아보연질캡슐",
    "아보스티드연질캡슐",
    "두타라이드연질캡슐",
    "두타스카연질캡슐",
    "아두타연질캡슐",
    "아보테드연질캡슐",
    "두타렉스연질캡슐",
    "원투스테리드연질캡슐",
    "두로칸연질캡슐",
    "두타젠연질캡슐",
    "아보두타연질캡슐",
    "다모다트연질캡슐",
    "아보타스연질캡슐",
    "아보탄연질캡슐",
    "두타드연질캡슐",
    "휴메리나연질캡슐",
    "두타겟연질캡슐",
    "두테론연질캡슐",
    "대웅바이오두타스테리드연질캡슐",
    "삼천당두타스테리드연질캡슐",
    "자이가드연질캡슐",
    "프로다트연질캡슐",
    "두타락연질캡슐",
    "안국두타스테리드연질캡슐",
    "유로다트연질캡슐",
    "타테린연질캡슐",
    "아다모연질캡슐",
    "두타케어정",
    "제이다트정",
    "두타반플러스정",
    "네오다트정",
    "엔피다트정",
    "두로케어정",
    "두아모정",
    "아보그로정",
    "두테스정",
    "대웅바이오두타스테리드정",
    "원투스테리드정",
    "두타론정",
    "다모다트정",
    "두타리드정",
    "두타브정",
    "아보타스정",
    "아보투윈연질캡슐",
    "에이두타정",
    "듀타그렌정",
    "두타스테린정",
    "아이두타연질캡슐",
    "두타온연질캡슐",
    "중헌두타스테리드연질캡슐",
    "두타그로연질캡슐",
    "아보다칸정",
    "두테론정",
    "모모타정",
    "두타윈연질캡슐",
    "두타스텐정",
    "두타모아정",
    "두타스타정",
    "보령두타스테리드연질캡슐",
    "팜젠두타스테리드연질캡슐",
    "아리드정",
    "두타엘정",
    "아다모정",
    "아보테드정",
    "두타린정",
    "삼성두타스테리드정",
    "아보리드정",
    "두리드정",
    "두타베린정",
    "두다트정",
    "케이두타다트정",
    "일성두타스테리드정",
    "두타겟정",
    "메가두타연질캡슐",
    "두타프렌정",
    "두보트정",
    "두타엠연질캡슐",
    "삼천당두타스테리드정",
    "두타시드정",
    "두타엠정",
    "두로칸정",
    "머카나정",
    "휴메리나정",
    "안국두타연질캡슐",
    "두모보연질캡슐",
    "아보텍트정",
    "두타모정",
    "모모다트정",
    "휴다트연질캡슐",
    "두리스연질캡슐",
    "동구두타리드연질캡슐",
    "아보엠연질캡슐",
    "모벤두타정",
    "에이두타연질캡슐", 
];
var semaglutides = [
    "위고비프리필드펜",
    "오젬픽프리필드펜",
    "리벨서스정"
];
var trifarotenes = [
    "아크리프"
];
var tirzepatides = [
    "마운자로프리필드펜"
];
//should change to use medicine code like app
var PHARMACY_MEDICINE_NAMES_MAP = {
    "1": {
        medicineList: finasterides,
        name: "피나스테리드"
    },
    "2": {
        medicineList: liraglutides,
        name: "리라글루티드"
    },
    "3": {
        medicineList: isotretinoins,
        name: "이소트레티노인"
    },
    "4": {
        medicineList: clindamycins,
        name: "클린다마이신"
    },
    "17": {
        medicineList: dutasterides,
        name: "두타스테리드"
    },
    "18": {
        medicineList: semaglutides,
        name: "세마글루티드"
    },
    "63": {
        medicineList: trifarotenes,
        name: "트리파로텐"
    },
    "64": {
        medicineList: tirzepatides,
        name: "터제파타이드"
    }
};

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/features/pharmacies/pharmacies-find/ui/MedicineInfoBottomSheet.tsx







var MedicineInfoBottomSheet = function(param) {
    var treatmentMedicineIds = param.treatmentMedicineIds, onClickClose = param.onClickClose;
    var ref = (0,react.useState)({}), hasOverflow = ref[0], setHasOverflow = ref[1];
    var ref1 = (0,react.useState)({}), expandedItems = ref1[0], setExpandedItems = ref1[1];
    var textRefs = (0,react.useRef)([]);
    // 선택된 약 그룹 정보 (없으면 빈 배열)
    var selectedMedicineGroup = treatmentMedicineIds.length > 1 && PHARMACY_MEDICINE_NAMES_MAP ? treatmentMedicineIds.map(function(id) {
        return PHARMACY_MEDICINE_NAMES_MAP[id];
    }).filter(Boolean) : [];
    // 더보기 핸들러
    var expandItem = function(index) {
        setExpandedItems(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, index, true));
        });
    };
    // 텍스트 오버플로우 감지
    (0,react.useEffect)(function() {
        if (selectedMedicineGroup.length === 0) return;
        // 요소가 렌더링된 후에 실행
        var checkOverflow = function() {
            var newHasOverflow = {};
            textRefs.current.forEach(function(ref, index) {
                if (ref) {
                    // scrollHeight > clientHeight 또는 scrollWidth > clientWidth일 경우 오버플로우 발생
                    var isOverflowing = ref.scrollHeight > ref.clientHeight || ref.scrollWidth > ref.clientWidth;
                    newHasOverflow[index] = isOverflowing;
                }
            });
            setHasOverflow(newHasOverflow);
        };
        checkOverflow();
        // 윈도우 리사이즈 시 오버플로우 상태 재확인
        window.addEventListener("resize", checkOverflow);
        return function() {
            window.removeEventListener("resize", checkOverflow);
        };
    }, [
        selectedMedicineGroup
    ]);
    var getDisplayedMedicineList = function(list) {
        if (!list || !list.length) return "";
        return list.join(", ");
    };
    // 약품 목록이 비어있는지 확인
    var isMedicineGroupEmpty = selectedMedicineGroup.length === 0;
    // 내용물 렌더링
    var renderContent = function() {
        // 목록이 비어있는 경우
        if (isMedicineGroupEmpty) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col space-y-8 pb-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col gap-2 px-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row items-start gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-[7px] h-1 w-1 rounded-full bg-gray-400"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "typography-ui-13m text-gray-500",
                                children: "선택된 약품이 없습니다."
                            })
                        ]
                    })
                })
            });
        }
        // 기본 약품 목록 표시
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col px-[4px] pb-6",
            children: [
                selectedMedicineGroup.map(function(medicine, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "typography-ui-15sb text-gray-900",
                                        children: medicine.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row items-center gap-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                ref: function(el) {
                                                    textRefs.current[index] = el;
                                                },
                                                className: "typography-ui-13r ".concat(!expandedItems[index] ? "line-clamp-1" : "", " flex-1 text-gray-600"),
                                                children: getDisplayedMedicineList(medicine.medicineList)
                                            }),
                                            hasOverflow[index] && !expandedItems[index] && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function() {
                                                    return expandItem(index);
                                                },
                                                className: "typography-ui-13r !underline cursor-pointer whitespace-nowrap border-0 bg-transparent text-gray-600 underline-offset-2",
                                                children: "더보기"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            index < selectedMedicineGroup.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "my-4 h-[1px] w-full bg-gray-40"
                            })
                        ]
                    }, index);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-4 mb-8 flex flex-col gap-2 px-1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-row items-start gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-[7px] h-[4px] min-w-[4px] rounded-full bg-gray-200"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "typography-ui-13m text-gray-400",
                                    children: "성분 선택은 진료 및 상담 과정에서 의사소통을 원활하게 하기 위한 목적으로 활용됩니다."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-row items-start gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-[7px] h-[4px] min-w-[4px] rounded-full bg-gray-200"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "typography-ui-13m text-gray-400",
                                    children: "약품명은 각 성분에 대한 이해를 돕기 위한 표기이며, 약품은 의사의 전문적 판단에 따라 처방됩니다."
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    // 오버레이 클릭 핸들러
    var handleOverlayClick = function() {
        onClickClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(overlay/* default */.Z, {
        onClickOverlay: handleOverlayClick,
        className: "!items-end",
        index: 500,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative max-h-[80vh] w-full max-w-full animate-slideUp overflow-y-scroll rounded-t-[24px] bg-white px-[20px] pt-[24px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb-4 flex flex-row items-center justify-between px-[4px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "typography-ui-20sb text-gray-800",
                        children: "성분 안내"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-h-[480px] overflow-y-scroll",
                    children: renderContent()
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: onClickClose,
                    className: "typography-ui-17sb mb-4 flex w-full items-center justify-center rounded-xl bg-primary-500 py-[15px] text-white hover:bg-primary-600",
                    children: "확인"
                })
            ]
        })
    });
};
/* harmony default export */ var ui_MedicineInfoBottomSheet = (MedicineInfoBottomSheet);


/***/ }),

/***/ 74815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pharmacy_map_header_tabs_PharmacyMapHeaderTabs; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/design-components/organisms/dnslide-tab/index.tsx
var dnslide_tab = __webpack_require__(25785);
// EXTERNAL MODULE: ./src/design-components/organisms/dnslide-tab/dnslide-tab-item/index.tsx
var dnslide_tab_item = __webpack_require__(36746);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/atom/skeleton/index.tsx + 1 modules
var skeleton = __webpack_require__(46799);
;// CONCATENATED MODULE: ./src/features/pharmacies/pharmacies-find/ui/EmptyTabsSkeleton.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 46px;\n  padding: 12px 0;\n  padding-left: 24px;\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var EmptyTabsSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                style: {
                    width: 50,
                    height: 22
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                style: {
                    width: 50,
                    height: 22
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                style: {
                    width: 80,
                    height: 22
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                style: {
                    width: 70,
                    height: 22
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                style: {
                    width: 80,
                    height: 22
                }
            })
        ]
    });
};
/* harmony default export */ var ui_EmptyTabsSkeleton = (EmptyTabsSkeleton);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-467a70ee-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    border-bottom: 1px solid ".concat(theme.color.gray100, ";\n  ");
});

;// CONCATENATED MODULE: ./src/features/pharmacies/shared/ui/pharmacy-map-header-tabs/PharmacyMapHeaderTabs.tsx




var PharmacyMapHeaderTabs = function(param) {
    var tabs = param.tabs, selectedTab = param.selectedTab, onClickTab = param.onClickTab;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: tabs ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dnslide_tab/* default */.Z, {
            value: selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.name,
            className: "z-[2] bg-white",
            children: tabs.map(function(tab) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(dnslide_tab_item/* default */.Z, {
                    label: tab.name,
                    isActive: (selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.id) === tab.id,
                    onClick: function() {
                        onClickTab(tab);
                    }
                }, tab.id);
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_EmptyTabsSkeleton, {})
    });
};
/* harmony default export */ var pharmacy_map_header_tabs_PharmacyMapHeaderTabs = (PharmacyMapHeaderTabs);


/***/ }),

/***/ 79832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getSearchCriteria */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26297);
/* harmony import */ var _parsers_f2f_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89325);
/* harmony import */ var _parsers_pharmacy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50635);
/* harmony import */ var _services_pharmacy_PharmacyPickupService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39826);
/* harmony import */ var _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72271);
/* harmony import */ var _shared_hooks_useDebounceWithLoading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78974);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2784);
/* harmony import */ var _pharmacy_gql_impl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39466);









var getSearchCriteria = function(diagnosisType, diagnosisTypeId, treatmentMedicineId, dispensationUnit, treatmentMedicineStrengthId) {
    if (!diagnosisType) {
        return {};
    }
    if (!diagnosisTypeId) {
        return {};
    }
    if (diagnosisType === _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .DiagnosisType.Treatment */ .LE2.Treatment) {
        return {
            medicineSearchCriteria: {
                treatmentId: diagnosisTypeId,
                treatmentMedicineId: treatmentMedicineId,
                dispensationUnit: dispensationUnit,
                treatmentMedicineStrengthId: treatmentMedicineStrengthId
            }
        };
    }
    if (diagnosisType === _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .DiagnosisType.Department */ .LE2.Department) {
        return {
            departmentSearchCriteria: {
                departmentId: diagnosisTypeId
            }
        };
    }
    return {};
};
var useFindGeneralListOfNearbyPharmacyV3ByUser = function(queryRequest) {
    var ref = (0,_shared_hooks_useDebounceWithLoading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(queryRequest, 500, {
        leading: false,
        trailing: true
    }), queryRequestDebounced = ref.debouncedValue, isQueryRequestDebouncedLoading = ref.isLoading;
    var latitude = queryRequestDebounced.latitude, longitude = queryRequestDebounced.longitude, diagnosisType = queryRequestDebounced.diagnosisType, diagnosisTypeId = queryRequestDebounced.diagnosisTypeId, treatmentMedicineId = queryRequestDebounced.treatmentMedicineId, dispensationUnit = queryRequestDebounced.dispensationUnit, treatmentMedicineStrengthId = queryRequestDebounced.treatmentMedicineStrengthId, shouldIncludeDiagnosisPrice = queryRequestDebounced.shouldIncludeDiagnosisPrice, restQuery = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(queryRequestDebounced, [
        "latitude",
        "longitude",
        "diagnosisType",
        "diagnosisTypeId",
        "treatmentMedicineId",
        "dispensationUnit",
        "treatmentMedicineStrengthId",
        "shouldIncludeDiagnosisPrice"
    ]);
    var isEnabled = function() {
        if (shouldIncludeDiagnosisPrice && !treatmentMedicineId && !dispensationUnit) {
            return false;
        }
        return !!restQuery.northEastLatitude && !!restQuery.northEastLongitude && !!restQuery.southWestLatitude && !!restQuery.southWestLongitude;
    };
    var mapCoordinate = _services_pharmacy_PharmacyPickupService__WEBPACK_IMPORTED_MODULE_2__/* .PharmacyPickupService.getMapCoordinate */ .B.getMapCoordinate(restQuery);
    var userCoordinate = (0,_parsers_f2f_common__WEBPACK_IMPORTED_MODULE_0__/* .getCoordinate */ .FY)(latitude, longitude);
    var ref1 = (0,_pharmacy_gql_impl__WEBPACK_IMPORTED_MODULE_6__/* .useFindGeneralListOfNearbyPharmacyV3ByUserQuery */ .xT)({
        request: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, {
            userLocation: {
                latitude: userCoordinate.latitude,
                longitude: userCoordinate.longitude
            },
            geoBound: {
                northEastLatitude: mapCoordinate.northEastLatitude,
                northEastLongitude: mapCoordinate.northEastLongitude,
                southWestLatitude: mapCoordinate.southWestLatitude,
                southWestLongitude: mapCoordinate.southWestLongitude
            },
            page: 1
        }, getSearchCriteria(diagnosisType, diagnosisTypeId, treatmentMedicineId, dispensationUnit, treatmentMedicineStrengthId)),
        treatmentId: diagnosisTypeId,
        treatmentMedicineId: treatmentMedicineId,
        dispensationUnit: dispensationUnit,
        treatmentMedicineStrengthId: treatmentMedicineStrengthId,
        shouldIncludeDispensableMedicine: !!treatmentMedicineId && !!dispensationUnit,
        shouldIncludeDiagnosisPrice: shouldIncludeDiagnosisPrice
    }, {
        select: _parsers_pharmacy__WEBPACK_IMPORTED_MODULE_1__/* .parseGeneralListOfNearbyPharmacy */ .af,
        enabled: isEnabled(),
        keepPreviousData: true
    }), _data = ref1.data, data = _data === void 0 ? [] : _data, isFetching = ref1.isFetching, isLoading = ref1.isLoading;
    var isVisibleMedicinePrice = (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(function() {
        return data.some(function(pharmacy) {
            return pharmacy.hasMedicinePrice();
        });
    }, [
        data
    ]);
    return {
        isLoading: isFetching || isLoading || isQueryRequestDebouncedLoading,
        data: data,
        isVisibleMedicinePrice: isVisibleMedicinePrice
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useFindGeneralListOfNearbyPharmacyV3ByUser);


/***/ }),

/***/ 65282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ non_benefit_map; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./src/components/atom/MaterialIcon.tsx
var MaterialIcon = __webpack_require__(17986);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
;// CONCATENATED MODULE: ./src/features/pharmacies/pharmacies-nonbenefit/ui/NonBenefitPharmacyHeader.tsx



var NonBenefitPharmacyHeader = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "z-[2] bg-white",
        children: props.isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
            className: "flex items-center justify-between px-6 pb-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "typography-ui-22sb",
                    children: props.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: props.handleOpenShareModal,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                        name: "share",
                        color: theme/* default.color.gray600 */.Z.color.gray600,
                        size: 24
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
            className: "flex h-12 items-center justify-between px-5 py-0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "typography-ui-22sb",
                    children: props.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    onClick: props.handleOpenShareModal,
                    className: "typography-ui-16sb flex flex h-12 items-center items-center gap-2 rounded-lg border border-gray-100 border-solid px-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                            name: "share",
                            color: theme/* default.color.gray600 */.Z.color.gray600,
                            size: 20
                        }),
                        "공유하기"
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ui_NonBenefitPharmacyHeader = (NonBenefitPharmacyHeader);

// EXTERNAL MODULE: ../../libs/ui/dist/index.es.js
var index_es = __webpack_require__(4601);
// EXTERNAL MODULE: ./src/features/pharmacies/shared/ui/filter/Filter.tsx
var Filter = __webpack_require__(85312);
// EXTERNAL MODULE: ./src/features/pharmacies/shared/ui/pharmacy-scroll-filters/PharmacyScrollFilters.tsx
var PharmacyScrollFilters = __webpack_require__(48768);
// EXTERNAL MODULE: ./src/components/common/ClickLogger.tsx
var ClickLogger = __webpack_require__(53157);
// EXTERNAL MODULE: ./src/constants/dd-actions/pharmacy/index.ts
var pharmacy = __webpack_require__(8574);
// EXTERNAL MODULE: ./src/features/pharmacies/shared/ui/modals/AddressesModal.tsx
var AddressesModal = __webpack_require__(89789);
// EXTERNAL MODULE: ./src/hooks/useModal.tsx
var useModal = __webpack_require__(98266);
// EXTERNAL MODULE: ./src/types/modal.ts
var modal = __webpack_require__(74701);
// EXTERNAL MODULE: ./src/utils/style.ts
var style = __webpack_require__(76666);
// EXTERNAL MODULE: ./src/features/pharmacies/pharmacies-find/ui/MedicineInfoBottomSheet.tsx + 1 modules
var MedicineInfoBottomSheet = __webpack_require__(53199);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./src/features/pharmacies/shared/hooks/usePharmacyFilterViewModel.ts
var usePharmacyFilterViewModel = __webpack_require__(65669);
// EXTERNAL MODULE: ./src/hooks/pharmacy/usePharmacyLocation.ts
var usePharmacyLocation = __webpack_require__(46088);
// EXTERNAL MODULE: ./src/models/pharmacy/index.ts
var models_pharmacy = __webpack_require__(75203);
;// CONCATENATED MODULE: ./src/features/pharmacies/pharmacies-nonbenefit/view-models/useNonBenefitPharmacyFilterViewModel.ts






function useNonBenefitPharmacyFilterViewModel(param) {
    var selectedTab = param.selectedTab, defaultSort = param.defaultSort, onApplyFilter = param.onApplyFilter, onClickCurrentLocation = param.onClickCurrentLocation;
    // 공통 필터 뷰모델 초기화
    var commonFilterViewModel = (0,usePharmacyFilterViewModel/* default */.Z)({
        selectedTab: selectedTab,
        defaultSort: defaultSort,
        nearbyPharmacySortsAndFilters: selectedTab ? {
            sorts: selectedTab.sortTypes,
            filters: selectedTab.filters
        } : undefined,
        onApplyFilter: onApplyFilter
    });
    // 약국 위치 관련 훅 초기화
    var locationHook = (0,usePharmacyLocation/* default */.Z)();
    // 약 정보 관련 상태
    var ref = (0,react.useState)(false), isMedicineInfoOpen = ref[0], setIsMedicineInfoOpen = ref[1];
    var ref1 = (0,react.useState)(false), isSortBottomSheetOpen = ref1[0], setIsSortBottomSheetOpen = ref1[1];
    // 주소 관련 액션
    var addressActions = {
        openAddressSelectModal: function() {
            return {
                addresses: locationHook.addresses,
                onOpenAddressListScreen: locationHook.goToAppMyPageAddressScreen,
                onRequestCurrentPosition: onClickCurrentLocation
            };
        }
    };
    // 바텀시트 핸들러
    var openSortBottomSheet = function() {
        return setIsSortBottomSheetOpen(true);
    };
    var closeSortBottomSheet = function() {
        return setIsSortBottomSheetOpen(false);
    };
    var handleMedicineInfoClick = function() {
        return setIsMedicineInfoOpen(true);
    };
    var handleCloseMedicineInfo = function() {
        return setIsMedicineInfoOpen(false);
    };
    // 필터 선택 핸들러
    var handleFilterClick = function(filter) {
        commonFilterViewModel.toggleFilter(filter);
    };
    // 정렬 선택 핸들러
    var handleSortSelected = (0,react.useCallback)(function(sort) {
        var newCriteria = {
            selectedMedicine: commonFilterViewModel.localFilterCriteria.selectedMedicine,
            selectedCommonFilters: commonFilterViewModel.localFilterCriteria.selectedCommonFilters,
            includeDiagnosisPriceFilter: commonFilterViewModel.localFilterCriteria.includeDiagnosisPriceFilter,
            selectedSortMethod: sort
        };
        onApplyFilter(newCriteria);
        closeSortBottomSheet();
    }, [
        commonFilterViewModel.localFilterCriteria,
        onApplyFilter
    ]);
    // 약 관련 핸들러
    var handleMedicineClick = (0,react.useCallback)(function(medicine) {
        var ref;
        if (!medicine.dispensationUnits.length) {
            return;
        }
        // 기본 단위 찾기 (isDefault가 true인 단위 또는 첫 번째 단위)
        var defaultUnit = medicine.dispensationUnits.find(function(unit) {
            return unit.isDefault;
        }) || medicine.dispensationUnits[0];
        var newMedicineFilter = new models_pharmacy/* MedicineFilterModel */.QP(medicine, defaultUnit, medicine.treatmentMedicineId, (ref = medicine.treatmentMedicineStrengths[0]) === null || ref === void 0 ? void 0 : ref.treatmentMedicineStrengthId);
        var newCriteria = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonFilterViewModel.localFilterCriteria), {
            selectedMedicine: newMedicineFilter
        });
        commonFilterViewModel.setLocalFilterCriteria(newCriteria);
        onApplyFilter(newCriteria);
    }, [
        commonFilterViewModel,
        onApplyFilter
    ]);
    var handleDispensationUnitClick = (0,react.useCallback)(function(unit) {
        var ref, ref1;
        if (!((ref = commonFilterViewModel.localFilterCriteria.selectedMedicine) === null || ref === void 0 ? void 0 : ref.treatmentMedicine)) {
            return;
        }
        var _treatmentMedicineStrengthId;
        var selectedStrength = (_treatmentMedicineStrengthId = commonFilterViewModel.localFilterCriteria.selectedMedicine.treatmentMedicineStrengthId) !== null && _treatmentMedicineStrengthId !== void 0 ? _treatmentMedicineStrengthId : (ref1 = commonFilterViewModel.localFilterCriteria.selectedMedicine.treatmentMedicine.treatmentMedicineStrengths[0]) === null || ref1 === void 0 ? void 0 : ref1.treatmentMedicineStrengthId;
        var newMedicineFilter = new models_pharmacy/* MedicineFilterModel */.QP(commonFilterViewModel.localFilterCriteria.selectedMedicine.treatmentMedicine, unit, commonFilterViewModel.localFilterCriteria.selectedMedicine.treatmentMedicineId, selectedStrength);
        var newCriteria = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonFilterViewModel.localFilterCriteria), {
            selectedMedicine: newMedicineFilter,
            includeDiagnosisPriceFilter: commonFilterViewModel.localFilterCriteria.includeDiagnosisPriceFilter
        });
        commonFilterViewModel.setLocalFilterCriteria(newCriteria);
        onApplyFilter(newCriteria);
    }, [
        commonFilterViewModel,
        onApplyFilter
    ]);
    var handleDispensationStrengthClick = (0,react.useCallback)(function(strength) {
        var ref;
        if (!((ref = commonFilterViewModel.localFilterCriteria.selectedMedicine) === null || ref === void 0 ? void 0 : ref.treatmentMedicine)) {
            return;
        }
        var _dispensationUnit;
        var selectedUnit = (_dispensationUnit = commonFilterViewModel.localFilterCriteria.selectedMedicine.dispensationUnit) !== null && _dispensationUnit !== void 0 ? _dispensationUnit : commonFilterViewModel.localFilterCriteria.selectedMedicine.treatmentMedicine.dispensationUnits.find(function(unit) {
            return unit.isDefault;
        }) || commonFilterViewModel.localFilterCriteria.selectedMedicine.treatmentMedicine.dispensationUnits[0];
        var newMedicineFilter = new models_pharmacy/* MedicineFilterModel */.QP(commonFilterViewModel.localFilterCriteria.selectedMedicine.treatmentMedicine, selectedUnit, commonFilterViewModel.localFilterCriteria.selectedMedicine.treatmentMedicineId, strength.treatmentMedicineStrengthId);
        var newCriteria = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonFilterViewModel.localFilterCriteria), {
            selectedMedicine: newMedicineFilter
        });
        commonFilterViewModel.setLocalFilterCriteria(newCriteria);
        onApplyFilter(newCriteria);
    }, [
        commonFilterViewModel,
        onApplyFilter
    ]);
    // 조건부 UI 표시 관련 함수
    var shouldShowTreatmentMedicineFilter = (0,react.useCallback)(function() {
        var ref;
        return !!(selectedTab === null || selectedTab === void 0 ? void 0 : (ref = selectedTab.treatmentMedicines) === null || ref === void 0 ? void 0 : ref.length);
    }, [
        selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.treatmentMedicines
    ]);
    var shouldShowDiagnosisPriceFilter = (0,react.useCallback)(function() {
        return !!commonFilterViewModel.localFilterCriteria.selectedMedicine;
    }, [
        commonFilterViewModel.localFilterCriteria.selectedMedicine
    ]);
    // 약/단위 선택 관련 헬퍼 함수
    var isMedicineSelected = (0,react.useCallback)(function(medicine) {
        var ref;
        return ((ref = commonFilterViewModel.localFilterCriteria.selectedMedicine) === null || ref === void 0 ? void 0 : ref.treatmentMedicine.treatmentMedicineId) === medicine.treatmentMedicineId;
    }, [
        commonFilterViewModel.localFilterCriteria.selectedMedicine
    ]);
    var getSelectedMedicineUnits = (0,react.useCallback)(function() {
        var ref;
        return ((ref = commonFilterViewModel.localFilterCriteria.selectedMedicine) === null || ref === void 0 ? void 0 : ref.treatmentMedicine.dispensationUnits) || [];
    }, [
        commonFilterViewModel.localFilterCriteria.selectedMedicine
    ]);
    var getSelectedMedicineStrengths = (0,react.useCallback)(function() {
        var ref;
        return ((ref = commonFilterViewModel.localFilterCriteria.selectedMedicine) === null || ref === void 0 ? void 0 : ref.treatmentMedicine.treatmentMedicineStrengths) || [];
    }, [
        commonFilterViewModel.localFilterCriteria.selectedMedicine
    ]);
    var isDispensationUnitSelected = (0,react.useCallback)(function(unit) {
        var ref, ref1;
        return ((ref = commonFilterViewModel.localFilterCriteria.selectedMedicine) === null || ref === void 0 ? void 0 : (ref1 = ref.dispensationUnit) === null || ref1 === void 0 ? void 0 : ref1.dispensationUnit) === unit.dispensationUnit;
    }, [
        commonFilterViewModel.localFilterCriteria.selectedMedicine
    ]);
    var isDispensationStrengthSelected = (0,react.useCallback)(function(strength) {
        var ref;
        return ((ref = commonFilterViewModel.localFilterCriteria.selectedMedicine) === null || ref === void 0 ? void 0 : ref.treatmentMedicineStrengthId) === strength.treatmentMedicineStrengthId;
    }, [
        commonFilterViewModel.localFilterCriteria.selectedMedicine
    ]);
    // 초기 약 선택 설정
    (0,react.useEffect)(function() {
        var ref;
        // 약이 있고 아직 선택되지 않았을 때만 처리
        if (!(selectedTab === null || selectedTab === void 0 ? void 0 : (ref = selectedTab.treatmentMedicines) === null || ref === void 0 ? void 0 : ref.length) || commonFilterViewModel.localFilterCriteria.selectedMedicine) {
            return;
        }
        var firstMedicine = selectedTab.treatmentMedicines[0];
        var defaultUnit = firstMedicine.dispensationUnits.find(function(unit) {
            return unit.isDefault;
        }) || firstMedicine.dispensationUnits[0];
        var defaultStrength = firstMedicine.treatmentMedicineStrengths.length > 0 ? firstMedicine.treatmentMedicineStrengths.find(function(medicine) {
            return medicine.isDefault;
        }) || firstMedicine.treatmentMedicineStrengths[0] : null;
        var newMedicineFilter = new models_pharmacy/* MedicineFilterModel */.QP(firstMedicine, defaultUnit, firstMedicine.treatmentMedicineId, defaultStrength === null || defaultStrength === void 0 ? void 0 : defaultStrength.treatmentMedicineStrengthId);
        var newCriteria = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonFilterViewModel.localFilterCriteria), {
            selectedMedicine: newMedicineFilter
        });
        commonFilterViewModel.setLocalFilterCriteria(newCriteria);
        onApplyFilter(newCriteria);
    }, [
        selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.treatmentMedicines,
        commonFilterViewModel,
        onApplyFilter
    ]);
    var ref2;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonFilterViewModel), {
        locationHook: locationHook,
        addressActions: addressActions,
        // 정렬 관련 상태 및 메서드
        isSortBottomSheetOpen: isSortBottomSheetOpen,
        openSortBottomSheet: openSortBottomSheet,
        closeSortBottomSheet: closeSortBottomSheet,
        // 필터 및 정렬 핸들러
        handleFilterClick: handleFilterClick,
        handleSortSelected: handleSortSelected,
        // 약 관련 상태 및 메서드
        isMedicineInfoOpen: isMedicineInfoOpen,
        handleMedicineInfoClick: handleMedicineInfoClick,
        handleCloseMedicineInfo: handleCloseMedicineInfo,
        treatmentMedicines: (ref2 = selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.treatmentMedicines) !== null && ref2 !== void 0 ? ref2 : [],
        handleMedicineClick: handleMedicineClick,
        handleDispensationUnitClick: handleDispensationUnitClick,
        handleDispensationStrengthClick: handleDispensationStrengthClick,
        shouldShowTreatmentMedicineFilter: shouldShowTreatmentMedicineFilter,
        isMedicineSelected: isMedicineSelected,
        getSelectedMedicineUnits: getSelectedMedicineUnits,
        getSelectedMedicineStrengths: getSelectedMedicineStrengths,
        isDispensationUnitSelected: isDispensationUnitSelected,
        isDispensationStrengthSelected: isDispensationStrengthSelected,
        shouldShowDiagnosisPriceFilter: shouldShowDiagnosisPriceFilter
    });
}

;// CONCATENATED MODULE: ./src/features/pharmacies/pharmacies-nonbenefit/ui/NonBenefitPharmacyHeaderFilter.tsx














var NonBenefitPharmacyHeaderFilter = function(props) {
    var ref, ref1;
    var ref2 = (0,useModal/* default */.Z)(), showModal = ref2.showModal, closeModal = ref2.closeModal;
    var viewModel = useNonBenefitPharmacyFilterViewModel({
        client: props.client,
        selectedTab: props.selectedTab,
        defaultSort: props.defaultSort,
        onApplyFilter: props.onApplyFilter,
        onClickCurrentLocation: props.onClickCurrentLocation
    });
    var openAddressSelectModal = function() {
        var addressOptions = viewModel.addressActions.openAddressSelectModal();
        showModal({
            type: modal/* MODAL_TYPE.BASIC */.f.BASIC,
            props: {
                body: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressesModal/* default */.Z, {
                    client: props.client,
                    addresses: addressOptions.addresses,
                    onOpenAddressListScreen: addressOptions.onOpenAddressListScreen,
                    onRequestCurrentPosition: function() {
                        var ref;
                        (ref = addressOptions.onRequestCurrentPosition) === null || ref === void 0 ? void 0 : ref.call(addressOptions);
                        closeModal();
                    }
                }),
                onClickOverlay: closeModal
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PharmacyScrollFilters/* default */.Z, {
                    pharmacyFilters: viewModel.searchFiltersHook.pharmacyFilterListWithoutIncludeDiagnosisPriceFilter,
                    onClickSearchCommonFilter: viewModel.handleFilterClick,
                    onClickListFilter: viewModel.handleFilterClick,
                    selectedFilters: viewModel.localFilterCriteria.selectedCommonFilters,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                            params: {
                                eventName: pharmacy/* PharmacyDdAction.ClickLocation */.Fe.ClickLocation,
                                payload: {
                                    location: props.currentDongLi
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Filter/* default.LargeFilter */.Z.LargeFilter, {
                                onClick: openAddressSelectModal,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                        name: "my_location",
                                        size: 16,
                                        color: theme/* default.color.gray700 */.Z.color.gray700,
                                        filled: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: props.currentDongLi
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mx-[4px] h-full min-w-[1px] bg-gray-30"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                            params: {
                                eventName: pharmacy/* PharmacyDdAction.ClickSort */.Fe.ClickSort
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Filter/* default.LargeFilter */.Z.LargeFilter, {
                                onClick: viewModel.openSortBottomSheet,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                        name: "swap_vert",
                                        size: 16,
                                        color: theme/* default.color.gray700 */.Z.color.gray700,
                                        filled: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: viewModel.localFilterCriteria.selectedSortMethod.title
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            viewModel.shouldShowTreatmentMedicineFilter() && viewModel.localFilterCriteria.selectedMedicine && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-full flex-col divide-y divide-solid divide-gray-30 bg-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex h-10 w-full flex-row items-center gap-[12px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex w-20 items-center gap-[2px] pl-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "typography-ui-13sb text-gray-800",
                                        children: "처방약"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "flex cursor-pointer items-center justify-center border-0 bg-none",
                                        onClick: viewModel.handleMedicineInfoClick,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/images/pharmacy/info_gray.svg",
                                            alt: "정보",
                                            width: "14",
                                            height: "14"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "scrollbar-hide flex flex-1 items-center gap-2 overflow-x-auto whitespace-nowrap pr-12",
                                children: (ref = viewModel.treatmentMedicines) === null || ref === void 0 ? void 0 : ref.map(function(medicine) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (0,style.cn)("typography-ui-13sb flex h-10 items-center px-1", viewModel.isMedicineSelected(medicine) ? "text-primary-700" : "typography-ui-13m text-gray-600"),
                                        onClick: function() {
                                            return viewModel.handleMedicineClick(medicine);
                                        },
                                        children: medicine.name
                                    }, medicine.treatmentMedicineId);
                                })
                            })
                        ]
                    }),
                    viewModel.getSelectedMedicineStrengths().length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex h-10 w-full flex-row items-center gap-[12px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex w-20 items-center pl-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "typography-ui-13sb text-gray-800",
                                    children: "처방용량"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "scrollbar-hide flex flex-1 items-center gap-2 overflow-x-auto whitespace-nowrap pr-12",
                                children: viewModel.getSelectedMedicineStrengths().map(function(strength) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (0,style.cn)("typography-ui-13sb flex h-10 items-center px-1", viewModel.isDispensationStrengthSelected(strength) ? "text-primary-700" : "typography-ui-13m text-gray-600"),
                                        onClick: function() {
                                            return viewModel.handleDispensationStrengthClick(strength);
                                        },
                                        children: strength.unit
                                    }, "non-benefit-medicine-strength-".concat(strength.treatmentMedicineStrengthId));
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex h-10 w-full flex-row items-center gap-[12px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex w-20 items-center pl-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "typography-ui-13sb text-gray-800",
                                    children: "처방단위"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "scrollbar-hide flex flex-1 items-center gap-2 overflow-x-auto whitespace-nowrap pr-12",
                                children: viewModel.getSelectedMedicineUnits().map(function(unit) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (0,style.cn)("typography-ui-13sb flex h-10 items-center px-1", viewModel.isDispensationUnitSelected(unit) ? "text-primary-700" : "typography-ui-13m text-gray-600"),
                                        onClick: function() {
                                            return viewModel.handleDispensationUnitClick(unit);
                                        },
                                        children: unit.dispensationUnitDisplayName
                                    }, unit.dispensationUnit);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* ActionSheet */.Vb, {
                open: viewModel.isSortBottomSheetOpen,
                onOpenChange: function(open) {
                    return !open && viewModel.closeSortBottomSheet();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* ActionSheetContent */.MG, {
                    title: "어떤 순서로 정렬할까요?",
                    closeOnOverlayClick: true,
                    children: viewModel.searchFiltersHook.pharmacySorts.map(function(sort, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* ActionSheetItem */.QI, {
                            label: sort.title,
                            selected: sort.type === viewModel.localFilterCriteria.selectedSortMethod.type,
                            onPress: function() {
                                return viewModel.handleSortSelected(sort);
                            }
                        }, "sort-".concat(index));
                    })
                })
            }),
            viewModel.isMedicineInfoOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(MedicineInfoBottomSheet/* default */.Z, {
                treatmentMedicineIds: ((ref1 = props.selectedTab) === null || ref1 === void 0 ? void 0 : ref1.treatmentMedicines.map(function(medicine) {
                    return medicine.treatmentMedicineId;
                })) || [],
                onClickClose: viewModel.handleCloseMedicineInfo
            })
        ]
    });
};
/* harmony default export */ var ui_NonBenefitPharmacyHeaderFilter = (NonBenefitPharmacyHeaderFilter);

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/atom/CustomBreadCrumbs.tsx
var CustomBreadCrumbs = __webpack_require__(12429);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/components/molecules/login-modal/index.tsx + 6 modules
var login_modal = __webpack_require__(26326);
// EXTERNAL MODULE: ./src/components/molecules/modal/select-modal/share-select-modal/index.tsx + 1 modules
var share_select_modal = __webpack_require__(45587);
// EXTERNAL MODULE: ./src/components/molecules/overlay/index.tsx + 1 modules
var overlay = __webpack_require__(48785);
// EXTERNAL MODULE: ./src/components/templates/communication/faq/faq-tag-list-template/index.tsx + 2 modules
var faq_tag_list_template = __webpack_require__(28265);
// EXTERNAL MODULE: ./src/constants/logs/pharmacy/index.tsx
var logs_pharmacy = __webpack_require__(15255);
// EXTERNAL MODULE: ./src/features/pharmacies/shared/ui/empty-pharmacy-toast/EmptyPharmacyToast.tsx
var EmptyPharmacyToast = __webpack_require__(26063);
// EXTERNAL MODULE: ./src/features/pharmacies/shared/ui/pharmacy-card-bottom-sheet/PharmacyCardBottomSheet.tsx + 3 modules
var PharmacyCardBottomSheet = __webpack_require__(58231);
// EXTERNAL MODULE: ./src/features/pharmacies/shared/ui/pharmacy-map-container/PharmacyMapContainer.tsx + 10 modules
var PharmacyMapContainer = __webpack_require__(92856);
// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ./src/types/pharmacy.ts
var types_pharmacy = __webpack_require__(6271);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(4611);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
// EXTERNAL MODULE: ./src/components/atom/icon/layout/HealthMedicalMedicines.tsx
var HealthMedicalMedicines = __webpack_require__(71305);
// EXTERNAL MODULE: ./src/entities/diagnosis/index.ts + 5 modules
var diagnosis = __webpack_require__(63507);
// EXTERNAL MODULE: ./src/entities/diagnosis/libs/constants.ts
var constants = __webpack_require__(36444);
// EXTERNAL MODULE: ./src/features/pharmacies/shared/ui/pharmacy-list-bottom-sheet/PharmacyListBottomSheet.tsx + 7 modules
var PharmacyListBottomSheet = __webpack_require__(18605);
// EXTERNAL MODULE: ./src/features/pharmacies/shared/ui/pharmacy-map-header-tabs/PharmacyMapHeaderTabs.tsx + 1 modules
var PharmacyMapHeaderTabs = __webpack_require__(74815);
// EXTERNAL MODULE: ./src/models/diagnosis/index.ts
var models_diagnosis = __webpack_require__(39591);
// EXTERNAL MODULE: ./src/components/templates/pharmacy/detail/components/pharmacy-info-header/index.tsx
var pharmacy_info_header = __webpack_require__(75995);
;// CONCATENATED MODULE: ./src/components/templates/non-benefit/map/NonBenefitMapTemplate.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n    flex-direction: column;\n    width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  height: 48px;\n  padding: 0 20px;\n  justify-content: center;\n  align-items: center;\n  background-color: ",
        ";\n  border-radius: 8px;\n  color: white;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-top: 20px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n    padding-top: 8px;\n  gap: 8px;;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}






























var GLOBAL_HEADER_HEIGHT = 60;
var NonBenefitMapTemplate = function(param) {
    var viewModel = param.viewModel, client = param.client, title = param.title;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var router = (0,next_router.useRouter)();
    var ref9 = (0,react.useState)(false), isShowShareModal = ref9[0], setShowShareModal = ref9[1];
    var diagnosisTypeId = (ref = viewModel.selectedTab) === null || ref === void 0 ? void 0 : ref.diagnosisTypeId;
    var treatmentProductMedicineName = (ref1 = viewModel.selectedMedicine) === null || ref1 === void 0 ? void 0 : ref1.treatmentProductMedicineName;
    var treatmentProductShareImageUrl = (ref2 = viewModel.selectedMedicine) === null || ref2 === void 0 ? void 0 : ref2.treatmentProductShareImageUrl;
    var treatmentMedicineId = (ref3 = viewModel.selectedTreatmentMedicine) === null || ref3 === void 0 ? void 0 : ref3.treatmentMedicineId;
    var treatmentMedicineUnitId = (ref4 = viewModel.selectedTreatmentMedicineUnit) === null || ref4 === void 0 ? void 0 : ref4.treatmentMedicineUnitId;
    var handleOpenShareModal = function() {
        setShowShareModal(true);
    };
    var handleCloseShareModal = function() {
        setShowShareModal(false);
    };
    var _selectedPharmacy, _diagnosisTypeId, ref10, ref11, ref12;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            client.clientType === app/* ClientType.WEB */.B.WEB && /*#__PURE__*/ (0,jsx_runtime.jsx)(faq_tag_list_template/* BreadCrumbsWrapper */.X, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBreadCrumbs/* default */.Z, {
                    visible: true,
                    breadCrumbs: viewModel.breadCrumbs
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Content */.Z.Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_NonBenefitPharmacyHeader, {
                                isMobile: client.isMobile,
                                title: title,
                                handleOpenShareModal: handleOpenShareModal
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PharmacyMapHeaderTabs/* default */.Z, {
                                tabs: viewModel.tabs,
                                selectedTab: viewModel.selectedTab,
                                onClickTab: viewModel.onClickTab
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PharmacyMapContainer/* default */.Z, {
                                selectedPharmacy: viewModel.selectedPharmacy,
                                updatePharmacyMapInitiateError: viewModel.updatePharmacyMapInitiateError,
                                level: 6,
                                isPharmaciesLoading: viewModel.isNearbyPharmaciesLoading,
                                centerCoordinate: viewModel.currentLocation,
                                pharmacies: viewModel.pharmacies,
                                updateDongLiName: viewModel.updateDongLiName,
                                updateMapCoordinate: viewModel.updateCurrentMapCoordinate,
                                isVisibleMedicinePrice: viewModel.isVisibleMedicinePrice,
                                shouldShowDiagnosisPrice: viewModel.isIncludeDiagnosisPriceFilterSelected,
                                resetSelectedPharmacy: viewModel.resetSelectedPharmacy,
                                updateSelectedPharmacy: viewModel.updateSelectedPharmacy,
                                mapRef: viewModel.mapRef,
                                headerHeight: (client.isMobile ? 156 : 152) - GLOBAL_HEADER_HEIGHT
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PharmacyListBottomSheet/* default */.Z, {
                        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_NonBenefitPharmacyHeaderFilter, {
                            client: client,
                            selectedTab: viewModel.selectedTab,
                            defaultSort: types_pharmacy/* ENearbyPharmacySearchSortType.LowPrice */.sZ.LowPrice,
                            currentDongLi: viewModel.dongLiName,
                            onApplyFilter: function(filterCriteria) {
                                return viewModel.applyFilter(filterCriteria);
                            },
                            onClickCurrentLocation: viewModel.onClickCurrentLocation
                        }),
                        client: client,
                        ref: viewModel.pharmacyListBottomSheetRef,
                        scrollListRef: viewModel.scrollListRef,
                        isNearbyPharmaciesLoading: viewModel.isNearbyPharmaciesLoading,
                        pharmacies: viewModel.pharmacies,
                        onClickPharmacyItem: viewModel.onClickPharmacyItem,
                        isIncludeDiagnosisPriceFilterSelected: viewModel.isIncludeDiagnosisPriceFilterSelected,
                        isVisibleMedicinePrice: viewModel.isVisibleMedicinePrice,
                        onClickCurrentLocation: viewModel.requestGeolocationPermissionInWeb,
                        headerHeight: client.isMobile ? 150 : 146,
                        shouldTransparent: viewModel.shouldShowPharmacyCard
                    }),
                    viewModel.shouldShowPharmacyCard && /*#__PURE__*/ (0,jsx_runtime.jsx)(PharmacyCardBottomSheet/* default */.Z, {
                        pharmacy: viewModel.selectedPharmacy,
                        isVisibleMedicinePrice: viewModel.isVisibleMedicinePrice,
                        shouldShowDiagnosisPrice: viewModel.isIncludeDiagnosisPriceFilterSelected,
                        clickViewListModeButton: viewModel.onClickViewListModeButtonWithResetSelectedPharmacy,
                        shouldShowPharmacyDetail: true,
                        onClickCurrentLocation: viewModel.requestGeolocationPermissionInWeb,
                        pharmacyMainInfoComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(pharmacy_info_header/* default */.Z, {
                            pharmacy: (_selectedPharmacy = viewModel.selectedPharmacy) !== null && _selectedPharmacy !== void 0 ? _selectedPharmacy : viewModel.pharmacies[0],
                            onClickFavoritePharmacy: function(e) {
                                var _selectedPharmacy;
                                viewModel.onClickFavoritePharmacy(e, (_selectedPharmacy = viewModel.selectedPharmacy) !== null && _selectedPharmacy !== void 0 ? _selectedPharmacy : viewModel.pharmacies[0]);
                            }
                        }),
                        client: client,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PharmacyCardBottomSheet/* default.ButtonArea */.Z.ButtonArea, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PharmacyDiagnosisActionButtonWrapper, {
                                    children: [
                                        viewModel.isEnabledWebDiagnosisCategory ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                                            params: {
                                                eventName: diagnosis/* EWebTreatmentRequestLog.ClickWebDiagnosisToRequest */.o5.ClickWebDiagnosisToRequest,
                                                payload: {
                                                    inflowType: constants/* EWebDiagnosisInflowType.NonBenefitMap */.G0.NonBenefitMap,
                                                    categoryId: (_diagnosisTypeId = viewModel.selectedTab.diagnosisTypeId) !== null && _diagnosisTypeId !== void 0 ? _diagnosisTypeId : "",
                                                    categoryType: models_diagnosis/* DiagnosisCategoryType.Treatment */.P2.Treatment,
                                                    categoryName: viewModel.selectedTab.name
                                                }
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PharmacyDiagnosisActionButton, {
                                                type: "button",
                                                onClick: viewModel.onClickCtaButton,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PharmacyDiagnosisActionButtonText, {
                                                    children: viewModel.getCtaButtonText()
                                                })
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                                            params: {
                                                eventName: logs_pharmacy/* FindPharmacyLog.click_pharmacy_diagnosis_button */.Vq.click_pharmacy_diagnosis_button,
                                                payload: {
                                                    pharmacyId: (ref10 = (ref5 = viewModel.selectedPharmacy) === null || ref5 === void 0 ? void 0 : ref5.pharmacyId) !== null && ref10 !== void 0 ? ref10 : 0,
                                                    price: ((ref11 = (ref6 = viewModel.selectedPharmacy) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.pharmacyDispensableMedicines) === null || ref7 === void 0 ? void 0 : ref7.totalAmount) !== null && ref11 !== void 0 ? ref11 : 0) + ((ref12 = (ref8 = viewModel.selectedPharmacy) === null || ref8 === void 0 ? void 0 : ref8.diagnosisPrice) !== null && ref12 !== void 0 ? ref12 : 0)
                                                }
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PharmacyDiagnosisActionButton, {
                                                type: "button",
                                                onClick: viewModel.onClickCtaButton,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PharmacyDiagnosisActionButtonText, {
                                                    children: viewModel.getCtaButtonText()
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventTextArea, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HealthMedicalMedicines/* default */.Z, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventTextWrapper, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EventText, {
                                                            children: "오늘 "
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightedEventText, {
                                                            children: "1,379명"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EventText, {
                                                            children: "이 ".concat(treatmentProductMedicineName, " 처방받았어요")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(share_select_modal/* default */.C, {
                isVisible: isShowShareModal,
                onClose: handleCloseShareModal,
                type: share_select_modal/* KAKAO_SHARE_TYPE.NON_BENEFIT_MAP */.Z.NON_BENEFIT_MAP,
                pageName: (0,logger/* getPageName */.j0)(router),
                kakaoShare: {
                    id: diagnosisTypeId !== null && diagnosisTypeId !== void 0 ? diagnosisTypeId : "",
                    subId: treatmentMedicineId !== null && treatmentMedicineId !== void 0 ? treatmentMedicineId : "",
                    title: "".concat(treatmentProductMedicineName, " 최저가 약국 찾기"),
                    content: "내 근처에서 가장 저렴한 ".concat(treatmentProductMedicineName, " 가격을 확인하고 비교할 수 있어요."),
                    imageUrl: treatmentProductShareImageUrl
                },
                copyLink: {
                    id: diagnosisTypeId !== null && diagnosisTypeId !== void 0 ? diagnosisTypeId : "",
                    copyElementId: "copyNonBenefitMap",
                    copyLinkUrl: "".concat((0,format/* formatShareUrl */.zm)(common/* ROUTES.NON_BENEFIT.MAP.path */.Z6.NON_BENEFIT.MAP.path), "?diagnosisTypeId=").concat(diagnosisTypeId, "&treatmentMedicineId=").concat(treatmentMedicineId, "&treatmentMedicineUnitId=").concat(treatmentMedicineUnitId, "&latitude=").concat(viewModel.currentMapLocation.latitude, "&longitude=").concat(viewModel.currentMapLocation.longitude)
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyPharmacyToast/* default */.Z, {
                shouldShowToast: viewModel.shouldShowEmptyPharmacyMessage()
            }),
            viewModel.showLoginModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(overlay/* default */.Z, {
                onClickOverlay: viewModel.closeLoginModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(login_modal/* default */.Z, {
                    isWritePage: false,
                    onClick: viewModel.closeLoginModal,
                    redirectUrl: "",
                    trackInfo: {
                        campaign: "doctor_detail",
                        content: "web_content_btn_details",
                        buttonText: "단골 의사 추가/삭제"
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var map_NonBenefitMapTemplate = (NonBenefitMapTemplate);
var ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5eca706f-0"
})(_templateObject());
var PharmacyDiagnosisActionButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5eca706f-1"
})(_templateObject1());
var PharmacyDiagnosisActionButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-5eca706f-2"
})(_templateObject2(), theme/* default.color.primary600 */.Z.color.primary600);
var PharmacyDiagnosisActionButtonText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-5eca706f-3"
})(_templateObject3(), function(param) {
    var _$theme = param.theme;
    return "\n    ".concat(_$theme.typography.UI16SB, "\n  ");
});
var BottomWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5eca706f-4"
})(_templateObject4());
var EventTextArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5eca706f-5"
})(_templateObject5());
var EventText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-5eca706f-6"
})(_templateObject6(), function(param) {
    var _$theme = param.theme;
    return "\n    ".concat(_$theme.typography.UI15M, ";\n    color: ").concat(_$theme.color.gray500, ";\n  ");
});
var HighlightedEventText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-5eca706f-7"
})(_templateObject7(), function(param) {
    var _$theme = param.theme;
    return "\n    ".concat(_$theme.typography.UI15SB, ";\n    color: ").concat(_$theme.color.primary700, ";\n  ");
});
var EventTextWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-5eca706f-8"
})(_templateObject8());

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./src/constants/url.ts
var url = __webpack_require__(26093);
// EXTERNAL MODULE: ./src/entities/non-benefit/index.ts + 16 modules
var non_benefit = __webpack_require__(65179);
// EXTERNAL MODULE: ./src/services/pharmacy/PharmacyPickupService.ts
var PharmacyPickupService = __webpack_require__(39826);
// EXTERNAL MODULE: ./src/utils/url.ts
var utils_url = __webpack_require__(74735);
;// CONCATENATED MODULE: ./src/features/pharmacies/shared/hooks/usePharmacyViewType.ts




var usePharmacyViewType = function() {
    var router = (0,next_router.useRouter)();
    var viewType = router.query.viewType;
    var pharmacyViewType = PharmacyPickupService/* PharmacyPickupService.getPharmacyViewType */.B.getPharmacyViewType(viewType);
    var shouldShowListView = pharmacyViewType === types_pharmacy/* EPharmacyViewType.List */.DO.List;
    var toggleViewMode = function() {
        (0,utils_url/* updateSearchParams */.aM)([
            {
                key: types_pharmacy/* PharmacySearchParamsQueries.ViewType */.Vc.ViewType,
                value: pharmacyViewType === types_pharmacy/* EPharmacyViewType.Map */.DO.Map ? types_pharmacy/* EPharmacyViewType.List */.DO.List : types_pharmacy/* EPharmacyViewType.Map */.DO.Map
            }, 
        ]);
    };
    return {
        pharmacyViewType: pharmacyViewType,
        shouldShowListView: shouldShowListView,
        toggleViewMode: toggleViewMode
    };
};
/* harmony default export */ var hooks_usePharmacyViewType = (usePharmacyViewType);

// EXTERNAL MODULE: ./src/parsers/f2f/common/index.ts
var f2f_common = __webpack_require__(89325);
// EXTERNAL MODULE: ./src/hooks/useToast.tsx
var useToast = __webpack_require__(17722);
;// CONCATENATED MODULE: ./src/hooks/common/useWebLocation.ts








var useWebLocation = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(""), dongLiName = ref[0], setDongLiName = ref[1];
    var showToast = (0,useToast/* default */.Z)().showToast;
    var _query = router.query, latitude = _query.latitude, longitude = _query.longitude;
    var currentLocation = (0,f2f_common/* getCoordinate */.FY)(latitude, longitude);
    var updateSearchParamsLocation = function(param) {
        var latitude = param.latitude, longitude = param.longitude;
        (0,utils_url/* updateSearchParams */.aM)([
            {
                key: types_pharmacy/* PharmacySearchParamsQueries.Latitude */.Vc.Latitude,
                value: latitude
            },
            {
                key: types_pharmacy/* PharmacySearchParamsQueries.Longitude */.Vc.Longitude,
                value: longitude
            }, 
        ]);
    };
    var requestGeolocationPermissionInWeb = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(callback) {
            var isToast;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                isToast = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                if (!navigator.geolocation) {
                    return [
                        2
                    ];
                }
                navigator.geolocation.getCurrentPosition(function(param) {
                    var coords = param.coords;
                    updateSearchParamsLocation({
                        latitude: coords.latitude,
                        longitude: coords.longitude
                    });
                    callback && callback({
                        latitude: coords.latitude,
                        longitude: coords.longitude
                    });
                }, function() {
                    if (!isToast) return;
                    showToast({
                        message: "위치 권한 허용 후 다시 시도해주세요"
                    });
                }, {
                    enableHighAccuracy: false,
                    timeout: 7000
                });
                return [
                    2
                ];
            });
        });
        return function requestGeolocationPermissionInWeb(callback) {
            return _ref.apply(this, arguments);
        };
    }();
    var updateDongLiName = function(currentDongLiName) {
        setDongLiName(currentDongLiName);
    };
    return {
        dongLiName: dongLiName,
        currentLocation: currentLocation,
        updateDongLiName: updateDongLiName,
        requestGeolocationPermissionInWeb: requestGeolocationPermissionInWeb
    };
};
/* harmony default export */ var common_useWebLocation = (useWebLocation);

// EXTERNAL MODULE: ./src/hooks/pharmacy/useFilteredAndSortedPharmacy.ts
var useFilteredAndSortedPharmacy = __webpack_require__(95782);
// EXTERNAL MODULE: ./src/hooks/pharmacy/useFindGeneralListOfNearbyPharmacyV3ByUser.ts
var useFindGeneralListOfNearbyPharmacyV3ByUser = __webpack_require__(79832);
// EXTERNAL MODULE: ./src/hooks/pharmacy/usePharmacySearchFilters.ts
var usePharmacySearchFilters = __webpack_require__(41841);
// EXTERNAL MODULE: ./src/views/non-benefit/index.ts + 2 modules
var views_non_benefit = __webpack_require__(13650);
// EXTERNAL MODULE: ./src/constants/category.ts
var category = __webpack_require__(26214);
// EXTERNAL MODULE: ./src/constants/logs/deeplink/index.ts
var deeplink = __webpack_require__(60643);
// EXTERNAL MODULE: ./src/constants/map/index.ts
var map = __webpack_require__(13805);
// EXTERNAL MODULE: ./src/constants/pixel.ts
var pixel = __webpack_require__(4380);
// EXTERNAL MODULE: ./src/entities/medical-category/index.ts + 4 modules
var medical_category = __webpack_require__(7551);
// EXTERNAL MODULE: ./src/entities/non-benefit/hooks/useGetNonBenefitDiagnosisPriceSupportInvitationCode.ts
var useGetNonBenefitDiagnosisPriceSupportInvitationCode = __webpack_require__(80316);
// EXTERNAL MODULE: ./src/entities/telemedicine/index.ts + 6 modules
var telemedicine = __webpack_require__(42491);
// EXTERNAL MODULE: ./src/shared/hooks/index.ts + 1 modules
var hooks = __webpack_require__(95613);
// EXTERNAL MODULE: ./src/utils/pixel/pixel.ts
var pixel_pixel = __webpack_require__(5863);
// EXTERNAL MODULE: ./src/hooks/login/useLoginViewModel.ts
var useLoginViewModel = __webpack_require__(97110);
// EXTERNAL MODULE: ./src/hooks/pharmacy/useAddFavoritePharmacy.ts
var useAddFavoritePharmacy = __webpack_require__(47272);
// EXTERNAL MODULE: ./src/hooks/pharmacy/useFavoritePharmacies.ts
var useFavoritePharmacies = __webpack_require__(8201);
// EXTERNAL MODULE: ./src/hooks/pharmacy/useRemoveFavoritePharmacy.ts
var useRemoveFavoritePharmacy = __webpack_require__(43928);
// EXTERNAL MODULE: ./src/hooks/useLogger.ts
var useLogger = __webpack_require__(8202);
// EXTERNAL MODULE: ./src/hooks/useNavigate.ts + 1 modules
var useNavigate = __webpack_require__(85180);
// EXTERNAL MODULE: ./src/hooks/useToaster.tsx
var useToaster = __webpack_require__(37643);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./src/utils/fetcher.ts
var fetcher = __webpack_require__(8391);
;// CONCATENATED MODULE: ./src/hooks/non-benefit/nonBenefit.gql.impl.tsx


var NonBenefitMapNearbyPharmacySearchTabsDocument = "\n    query NonBenefitMapNearbyPharmacySearchTabs {\n  nonBenefitMapNearbyPharmacySearchTabs {\n    id\n    name\n    diagnosisType\n    diagnosisTypeId\n    sortTypes {\n      type\n      title\n    }\n    filters {\n      type\n      title\n      description\n      mode\n      activeIconUrl\n      inactiveIconUrl\n      subFilters {\n        type\n        title\n        description\n        mode\n        inactiveIconUrl\n        activeIconUrl\n      }\n    }\n    treatmentMedicines {\n      id\n      treatmentId\n      name\n      description\n      dispensationUnits {\n        isDefault\n        dispensationUnit\n        dispensationUnitDisplayName\n        treatmentMedicineId\n        treatmentMedicineUnitId\n      }\n      treatmentMedicineStrengths {\n        treatmentMedicineStrengthId\n        unit\n        treatmentMedicineId\n        isDefault\n      }\n    }\n  }\n}\n    ";
var useNonBenefitMapNearbyPharmacySearchTabsQuery = function(variables, options) {
    return (0,useQuery/* useQuery */.a)(variables === undefined ? [
        "NonBenefitMapNearbyPharmacySearchTabs"
    ] : [
        "NonBenefitMapNearbyPharmacySearchTabs",
        variables
    ], (0,fetcher/* gqlFetcher */.l3)(NonBenefitMapNearbyPharmacySearchTabsDocument, "NonBenefitMapNearbyPharmacySearchTabs", variables), options);
};
useNonBenefitMapNearbyPharmacySearchTabsQuery.getKey = function(variables) {
    return variables === undefined ? [
        "NonBenefitMapNearbyPharmacySearchTabs"
    ] : [
        "NonBenefitMapNearbyPharmacySearchTabs",
        variables
    ];
};
useNonBenefitMapNearbyPharmacySearchTabsQuery.fetcher = function(variables, options) {
    return (0,fetcher/* gqlFetcher */.l3)(NonBenefitMapNearbyPharmacySearchTabsDocument, "NonBenefitMapNearbyPharmacySearchTabs", variables, options);
};

// EXTERNAL MODULE: ./src/services/pharmacy/TreatmentMedicineService.ts
var TreatmentMedicineService = __webpack_require__(81723);
// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
;// CONCATENATED MODULE: ./src/hooks/non-benefit/useNonBenefitMapNearbyPharmacySearchTabs.ts







// 타입 변환 매퍼 함수
var mapToPharmacyFilterMode = function(mode) {
    // PharmacyFilterMode와 EPharmacyFilterMode는 동일한 값을 가지므로 직접 매핑 가능
    switch(mode){
        case gql_schema/* PharmacyFilterMode.List */.T4Y.List:
            return types_pharmacy/* EPharmacyFilterMode.List */.LR.List;
        case gql_schema/* PharmacyFilterMode.Toggle */.T4Y.Toggle:
            return types_pharmacy/* EPharmacyFilterMode.Toggle */.LR.Toggle;
        case gql_schema/* PharmacyFilterMode.Range */.T4Y.Range:
            return types_pharmacy/* EPharmacyFilterMode.Range */.LR.Range;
        default:
            return types_pharmacy/* EPharmacyFilterMode.Toggle */.LR.Toggle;
    }
};
var mapToPharmacySearchFilterType = function(type) {
    // PharmacyFilterType을 ENearbyPharmacySearchFilterType으로 매핑
    switch(type){
        case gql_schema/* PharmacyFilterType.ConfirmedDispensation */.A1u.ConfirmedDispensation:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.ConfirmedDispensation */.aT.ConfirmedDispensation;
        case gql_schema/* PharmacyFilterType.DispensationProbability */.A1u.DispensationProbability:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.DispensationProbability */.aT.DispensationProbability;
        case gql_schema/* PharmacyFilterType.HandlingMedicine */.A1u.HandlingMedicine:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.HandlingMedicine */.aT.HandlingMedicine;
        case gql_schema/* PharmacyFilterType.HighDispensationProbability */.A1u.HighDispensationProbability:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.HighDispensationProbability */.aT.HighDispensationProbability;
        case gql_schema/* PharmacyFilterType.IncludeDiagnosisPrice */.A1u.IncludeDiagnosisPrice:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.IncludeDiagnosisPrice */.aT.IncludeDiagnosisPrice;
        case gql_schema/* PharmacyFilterType.IsOpenAtLateNight */.A1u.IsOpenAtLateNight:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.IsOpenAtLateNight */.aT.IsOpenAtLateNight;
        case gql_schema/* PharmacyFilterType.IsOpenEveryDay */.A1u.IsOpenEveryDay:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.IsOpenEveryDay */.aT.IsOpenEveryDay;
        case gql_schema/* PharmacyFilterType.Now */.A1u.Now:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.Now */.aT.Now;
        case gql_schema/* PharmacyFilterType.Operating */.A1u.Operating:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.Operating */.aT.Operating;
        case gql_schema/* PharmacyFilterType.PossibleDispensation */.A1u.PossibleDispensation:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.PossibleDispensation */.aT.PossibleDispensation;
        case gql_schema/* PharmacyFilterType.RequestWithApp */.A1u.RequestWithApp:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.RequestWithApp */.aT.RequestWithApp;
        case gql_schema/* PharmacyFilterType.SameMedicine */.A1u.SameMedicine:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.SameMedicine */.aT.SameMedicine;
        // FavoritePharmacy, Partnership, TreatmentMedicine는 없으므로 기본값 반환
        default:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.CheapPrice */.aT.CheapPrice;
    }
};
var mapToPharmacySortsVo = function(sort) {
    // PharmacySortType을 ENearbyPharmacySearchSortType으로 매핑
    var sortType;
    switch(sort.type){
        case gql_schema/* PharmacySortType.Distance */.f$c.Distance:
            sortType = types_pharmacy/* ENearbyPharmacySearchSortType.Distance */.sZ.Distance;
            break;
        case gql_schema/* PharmacySortType.LowPrice */.f$c.LowPrice:
            sortType = types_pharmacy/* ENearbyPharmacySearchSortType.LowPrice */.sZ.LowPrice;
            break;
        case gql_schema/* PharmacySortType.QuickReceipt */.f$c.QuickReceipt:
            sortType = types_pharmacy/* ENearbyPharmacySearchSortType.QuickReceipt */.sZ.QuickReceipt;
            break;
        case gql_schema/* PharmacySortType.VisitCount */.f$c.VisitCount:
            sortType = types_pharmacy/* ENearbyPharmacySearchSortType.VisitCount */.sZ.VisitCount;
            break;
        case gql_schema/* PharmacySortType.MostReviews */.f$c.MostReviews:
            sortType = types_pharmacy/* ENearbyPharmacySearchSortType.MostReviews */.sZ.MostReviews;
            break;
        case gql_schema/* PharmacySortType.HighRating */.f$c.HighRating:
            sortType = types_pharmacy/* ENearbyPharmacySearchSortType.HighRating */.sZ.HighRating;
            break;
        // DispensationProbability는 ENearbyPharmacySearchSortType에 없음 -> 기본값 사용
        default:
            sortType = types_pharmacy/* ENearbyPharmacySearchSortType.QuickReceipt */.sZ.QuickReceipt;
    }
    return {
        title: sort.title,
        type: sortType
    };
};
var parseNonBenefitMapNearByPharmacySearchTabsVo = function(data) {
    return data.nonBenefitMapNearbyPharmacySearchTabs.map(function(item) {
        var _diagnosisTypeId;
        return {
            id: item.id,
            name: item.name,
            diagnosisType: item.diagnosisType,
            diagnosisTypeId: (_diagnosisTypeId = item.diagnosisTypeId) !== null && _diagnosisTypeId !== void 0 ? _diagnosisTypeId : null,
            filters: item.filters.map(function(filter) {
                var _activeIconUrl, _inactiveIconUrl, _title, _description;
                return new models_pharmacy/* NearbyPharmacyFilterModel */.QJ({
                    activeIconUrl: (_activeIconUrl = filter.activeIconUrl) !== null && _activeIconUrl !== void 0 ? _activeIconUrl : undefined,
                    inactiveIconUrl: (_inactiveIconUrl = filter.inactiveIconUrl) !== null && _inactiveIconUrl !== void 0 ? _inactiveIconUrl : undefined,
                    mode: mapToPharmacyFilterMode(filter.mode),
                    title: (_title = filter.title) !== null && _title !== void 0 ? _title : "",
                    description: (_description = filter.description) !== null && _description !== void 0 ? _description : "",
                    type: mapToPharmacySearchFilterType(filter.type),
                    subFilters: filter.subFilters.map(function(subFilter) {
                        var _title, _description;
                        return new models_pharmacy/* NearbyPharmacyFilterModel */.QJ({
                            mode: mapToPharmacyFilterMode(subFilter.mode),
                            title: (_title = subFilter.title) !== null && _title !== void 0 ? _title : "",
                            description: (_description = subFilter.description) !== null && _description !== void 0 ? _description : "",
                            type: mapToPharmacySearchFilterType(subFilter.type),
                            subFilters: []
                        });
                    })
                });
            }),
            sortTypes: item.sortTypes.map(function(type) {
                return mapToPharmacySortsVo(type);
            }),
            treatmentMedicines: item.treatmentMedicines.map(function(medicine) {
                var _description;
                return {
                    treatmentMedicineId: medicine.id,
                    treatmentId: medicine.treatmentId,
                    name: medicine.name,
                    description: (_description = medicine.description) !== null && _description !== void 0 ? _description : undefined,
                    isNew: TreatmentMedicineService/* default.isNewMedicine */.Z.isNewMedicine(medicine.id),
                    treatmentMedicineStrengths: medicine.treatmentMedicineStrengths.map(function(strength) {
                        return {
                            treatmentMedicineStrengthId: strength.treatmentMedicineStrengthId,
                            treatmentMedicineId: strength.treatmentMedicineId,
                            unit: strength.unit,
                            isDefault: strength.isDefault
                        };
                    }),
                    dispensationUnits: medicine.dispensationUnits.map(function(unit) {
                        return {
                            isDefault: unit.isDefault,
                            dispensationUnit: unit.dispensationUnit,
                            dispensationUnitDisplayName: unit.dispensationUnitDisplayName,
                            treatmentMedicineId: Number(unit.treatmentMedicineId),
                            treatmentMedicineUnitId: Number(unit.treatmentMedicineUnitId)
                        };
                    })
                };
            })
        };
    });
};
var useNonBenefitMapNearByPharmacySearchTabs = function() {
    var ref = useNonBenefitMapNearbyPharmacySearchTabsQuery({}, {
        select: parseNonBenefitMapNearByPharmacySearchTabsVo,
        staleTime: 1000 * 60 * 5
    }), _data = ref.data, data = _data === void 0 ? [] : _data;
    return {
        data: data
    };
};
/* harmony default export */ var useNonBenefitMapNearbyPharmacySearchTabs = (useNonBenefitMapNearByPharmacySearchTabs);
var fetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient) {
        var response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.fetchQuery(useNonBenefitMapNearbyPharmacySearchTabsQuery.getKey({}), useNonBenefitMapNearbyPharmacySearchTabsQuery.fetcher({}))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        parseNonBenefitMapNearByPharmacySearchTabsVo(response)
                    ];
            }
        });
    });
    return function fetchQuery(queryClient) {
        return _ref.apply(this, arguments);
    };
}();
useNonBenefitMapNearByPharmacySearchTabs.fetchQuery = fetchQuery;

;// CONCATENATED MODULE: ./src/hooks/non-benefit/useNonBenefitMapCategoryTabs.ts








var useNonBenefitMapCategoryTabs = function() {
    var router = (0,next_router.useRouter)();
    var _query = router.query, _diagnosisTypeId = _query.diagnosisTypeId, diagnosisTypeId = _diagnosisTypeId === void 0 ? "" : _diagnosisTypeId, _treatmentMedicineId = _query.treatmentMedicineId, treatmentMedicineId = _treatmentMedicineId === void 0 ? "" : _treatmentMedicineId, _treatmentMedicineUnitId = _query.treatmentMedicineUnitId, treatmentMedicineUnitId = _treatmentMedicineUnitId === void 0 ? "" : _treatmentMedicineUnitId, _treatmentMedicineStrengthId = _query.treatmentMedicineStrengthId, treatmentMedicineStrengthId = _treatmentMedicineStrengthId === void 0 ? "" : _treatmentMedicineStrengthId;
    var ref = useNonBenefitMapNearbyPharmacySearchTabs(), tabs = ref.data;
    var selectedTab = (0,react.useMemo)(function() {
        var ref;
        return (ref = tabs.find(function(tab) {
            return tab.diagnosisTypeId === diagnosisTypeId;
        })) !== null && ref !== void 0 ? ref : tabs[0];
    }, [
        tabs,
        diagnosisTypeId
    ]);
    var selectedTreatmentMedicine = (0,react.useMemo)(function() {
        var ref;
        return (ref = selectedTab.treatmentMedicines.find(function(medicine) {
            return medicine.treatmentMedicineId === treatmentMedicineId;
        })) !== null && ref !== void 0 ? ref : selectedTab.treatmentMedicines[0];
    }, [
        selectedTab,
        treatmentMedicineId
    ]);
    var selectedTreatmentMedicineUnit = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = (ref = selectedTreatmentMedicine.dispensationUnits.findLast(function(unit) {
            return unit.treatmentMedicineUnitId === Number(treatmentMedicineUnitId);
        })) !== null && ref !== void 0 ? ref : selectedTreatmentMedicine.dispensationUnits.find(function(unit) {
            return unit.isDefault;
        })) !== null && ref1 !== void 0 ? ref1 : selectedTreatmentMedicine.dispensationUnits[0];
    }, [
        selectedTreatmentMedicine,
        treatmentMedicineUnitId
    ]);
    var selectedTreatmentMedicineStrength = (0,react.useMemo)(function() {
        if (!selectedTreatmentMedicine.treatmentMedicineStrengths.length) return null;
        var ref;
        return (ref = selectedTreatmentMedicine.treatmentMedicineStrengths.find(function(strength) {
            return strength.treatmentMedicineStrengthId === treatmentMedicineStrengthId;
        })) !== null && ref !== void 0 ? ref : selectedTreatmentMedicine.treatmentMedicineStrengths[0];
    }, [
        selectedTreatmentMedicine,
        treatmentMedicineStrengthId
    ]);
    var shouldIncludeDiagnosisPrice = selectedTab.filters.some(function(filter) {
        return filter.type === types_pharmacy/* ENearbyPharmacySearchFilterType.IncludeDiagnosisPrice */.aT.IncludeDiagnosisPrice;
    });
    var log = (0,useLogger/* default */.Z)().log;
    var selectTab = function(tab) {
        var defaultTreatmentMedicine = tab.treatmentMedicines[0];
        var defaultDispensationUnit = defaultTreatmentMedicine.dispensationUnits.find(function(unit) {
            return unit.isDefault;
        }) || defaultTreatmentMedicine.dispensationUnits[0];
        var defaultTreatmentMedicineStrength = defaultTreatmentMedicine.treatmentMedicineStrengths.length > 0 ? defaultTreatmentMedicine.treatmentMedicineStrengths.find(function(strength) {
            return strength.isDefault;
        }) || defaultTreatmentMedicine.treatmentMedicineStrengths[0] : null;
        var _diagnosisType, _diagnosisTypeId, _treatmentMedicineId, _treatmentMedicineUnitId, _treatmentMedicineStrengthId;
        (0,utils_url/* updateSearchParams */.aM)([
            {
                key: "diagnosisType",
                value: (_diagnosisType = tab.diagnosisType) !== null && _diagnosisType !== void 0 ? _diagnosisType : ""
            },
            {
                key: "diagnosisTypeId",
                value: (_diagnosisTypeId = tab.diagnosisTypeId) !== null && _diagnosisTypeId !== void 0 ? _diagnosisTypeId : ""
            },
            {
                key: "treatmentMedicineId",
                value: (_treatmentMedicineId = defaultTreatmentMedicine.treatmentMedicineId) !== null && _treatmentMedicineId !== void 0 ? _treatmentMedicineId : ""
            },
            {
                key: "treatmentMedicineUnitId",
                value: (_treatmentMedicineUnitId = defaultDispensationUnit.treatmentMedicineUnitId) !== null && _treatmentMedicineUnitId !== void 0 ? _treatmentMedicineUnitId : ""
            }, 
        ].concat((0,_to_consumable_array/* default */.Z)(defaultTreatmentMedicineStrength ? [
            {
                key: "treatmentMedicineStrengthId",
                value: (_treatmentMedicineStrengthId = defaultTreatmentMedicineStrength.treatmentMedicineStrengthId) !== null && _treatmentMedicineStrengthId !== void 0 ? _treatmentMedicineStrengthId : ""
            }, 
        ] : [
            {
                key: "treatmentMedicineStrengthId",
                value: ""
            }
        ])));
        log({
            eventName: "".concat(pharmacy/* FindPharmacyDdAction.ClickTab */.vy.ClickTab, "-").concat(tab.id)
        });
    };
    return {
        tabs: tabs,
        selectedTab: selectedTab,
        selectTab: selectTab,
        selectedTreatmentMedicine: selectedTreatmentMedicine,
        selectedTreatmentMedicineUnit: selectedTreatmentMedicineUnit,
        selectedTreatmentMedicineStrength: selectedTreatmentMedicineStrength,
        shouldIncludeDiagnosisPrice: shouldIncludeDiagnosisPrice
    };
};
/* harmony default export */ var non_benefit_useNonBenefitMapCategoryTabs = (useNonBenefitMapCategoryTabs);

;// CONCATENATED MODULE: ./src/hooks/non-benefit/useNonBenefitMapViewModel.tsx








































var airbrigdeLink = "https://abr.ge/w3tbbv";
var useNonBenefitMapViewModel = function(client) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var router = (0,next_router.useRouter)();
    var navigate = (0,useNavigate/* default */.Z)();
    var queries = router.query;
    var ref10 = non_benefit_useNonBenefitMapCategoryTabs(), tabs = ref10.tabs, selectedTab = ref10.selectedTab, selectTab = ref10.selectTab, selectedTreatmentMedicine = ref10.selectedTreatmentMedicine, selectedTreatmentMedicineUnit = ref10.selectedTreatmentMedicineUnit;
    var toast = (0,index_es/* useToast */.pm)().toast;
    var onClickTelemedicineRequest = (0,telemedicine/* useTelemedicineRequest */.UO)().onClickTelemedicineRequest;
    var airbridgeDynamicLink = (0,hooks/* useAirbridgeDynamicLink */.e)();
    var mapRef = (0,react.useRef)(null);
    var pharmacyListBottomSheetRef = (0,react.useRef)(null);
    var ref11 = (0,useModal/* default */.Z)(), showModal = ref11.showModal, closeModal = ref11.closeModal;
    var breadCrumbs = [
        {
            label: "최저가 약국 찾기",
            url: common/* ROUTES.NON_BENEFIT.MAP.path */.Z6.NON_BENEFIT.MAP.path + (0,utils_url/* addQueryString */.sC)(queries),
            logName: "non_benefit_map"
        }, 
    ];
    var scrollListRef = (0,react.useRef)(null);
    var userLocationHook = common_useWebLocation();
    var ref12 = (0,react.useState)(null), selectedPharmacy = ref12[0], setSelectedPharmacy = ref12[1];
    var ref13 = (0,react.useState)(null), pharmacyMapInitiateError = ref13[0], setPharmacyMapInitiateError = ref13[1];
    var ref14 = (0,react.useState)(null), pharmacyFilterCriteria = ref14[0], setPharmacyFilterCriteria = ref14[1];
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var addFavoritePharmacyMutation = (0,useAddFavoritePharmacy/* default */.Z)().addFavoritePharmacyMutation;
    var removeFavoritePharmacyMutation = (0,useRemoveFavoritePharmacy/* default */.Z)().removeFavoritePharmacyMutation;
    var invitationCode = (0,useGetNonBenefitDiagnosisPriceSupportInvitationCode/* default */.Z)().invitationCode;
    var showToast = (0,useToaster/* default */.Z)().showToast;
    var log = (0,useLogger/* default */.Z)().log;
    var loginViewModel = (0,useLoginViewModel/* default */.Z)();
    var ref15 = (0,react.useState)(false), showLoginModal = ref15[0], setShowLoginModal = ref15[1];
    var openLoginModal = function() {
        setShowLoginModal(true);
    };
    var closeLoginModal = function() {
        setShowLoginModal(false);
    };
    var shouldShowPharmacyCard = !!selectedPharmacy;
    var updateSelectedPharmacy = function(pharmacy) {
        pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.SelectPharmacy */.$.SelectPharmacy, {
            drug: selectedMedicine.medicineDisplayName
        });
        setSelectedPharmacy(pharmacy);
        if (pharmacyListBottomSheetRef.current) {
            var ref;
            (ref = pharmacyListBottomSheetRef.current) === null || ref === void 0 ? void 0 : ref.setInitialSnapPoint();
        }
    };
    var resetSelectedPharmacy = function() {
        setSelectedPharmacy(null);
        if (pharmacyListBottomSheetRef.current) {
            var ref;
            (ref = pharmacyListBottomSheetRef.current) === null || ref === void 0 ? void 0 : ref.setInitialSnapPoint();
        }
    };
    var updatePharmacyMapInitiateError = function(error) {
        setPharmacyMapInitiateError(error);
    };
    var pharmacyViewTypeHook = hooks_usePharmacyViewType();
    var ref16, ref17, _type;
    var searchFiltersHook = (0,usePharmacySearchFilters/* default */.Z)({
        nearbyPharmacySortsAndFilters: {
            filters: (ref16 = selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.filters) !== null && ref16 !== void 0 ? ref16 : [],
            sorts: (ref17 = selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.sortTypes) !== null && ref17 !== void 0 ? ref17 : []
        },
        defaultSortType: (_type = selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.sortTypes[0].type) !== null && _type !== void 0 ? _type : types_pharmacy/* ENearbyPharmacySearchSortType.LowPrice */.sZ.LowPrice
    });
    var ref18, ref19;
    var ref20 = (0,useFindGeneralListOfNearbyPharmacyV3ByUser/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchFiltersHook.getBoundaryEastWestLongitudeAndLatitude(!!pharmacyMapInitiateError)), {
        latitude: searchFiltersHook.mapCoordinates.latitude,
        longitude: searchFiltersHook.mapCoordinates.longitude,
        diagnosisType: pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref = pharmacyFilterCriteria.selectedTab) === null || ref === void 0 ? void 0 : ref.diagnosisType,
        diagnosisTypeId: pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref1 = pharmacyFilterCriteria.selectedTab) === null || ref1 === void 0 ? void 0 : ref1.diagnosisTypeId,
        treatmentMedicineId: pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref2 = pharmacyFilterCriteria.selectedMedicine) === null || ref2 === void 0 ? void 0 : ref2.treatmentMedicineId,
        dispensationUnit: pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref3 = pharmacyFilterCriteria.selectedMedicine) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.dispensationUnit) === null || ref4 === void 0 ? void 0 : ref4.dispensationUnit,
        treatmentMedicineStrengthId: pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref5 = pharmacyFilterCriteria.selectedMedicine) === null || ref5 === void 0 ? void 0 : ref5.treatmentMedicineStrengthId,
        shouldIncludeDiagnosisPrice: (ref19 = (pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref6 = pharmacyFilterCriteria.selectedTab) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.filters) === null || ref7 === void 0 ? void 0 : ref7.some(function(filter) {
            return filter.type === types_pharmacy/* ENearbyPharmacySearchFilterType.IncludeDiagnosisPrice */.aT.IncludeDiagnosisPrice;
        })) && (pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref8 = pharmacyFilterCriteria.includeDiagnosisPriceFilter) === null || ref8 === void 0 ? void 0 : ref8.isSelectedFilter((ref18 = pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : pharmacyFilterCriteria.selectedCommonFilters) !== null && ref18 !== void 0 ? ref18 : []))) !== null && ref19 !== void 0 ? ref19 : false
    })), rawPharmacyList = ref20.data, isNearbyPharmaciesLoading = ref20.isLoading, isVisibleMedicinePrice = ref20.isVisibleMedicinePrice;
    var ref21;
    var ref22 = (0,useFilteredAndSortedPharmacy/* default */.Z)({
        filters: (ref21 = pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : pharmacyFilterCriteria.selectedCommonFilters) !== null && ref21 !== void 0 ? ref21 : [],
        sortType: pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : pharmacyFilterCriteria.selectedSortMethod.type,
        pharmacyQueryData: {
            isLoading: isNearbyPharmaciesLoading,
            rawPharmacyData: rawPharmacyList !== null && rawPharmacyList !== void 0 ? rawPharmacyList : []
        },
        shouldFilterByPriceMedicine: !!(pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref9 = pharmacyFilterCriteria.selectedMedicine) === null || ref9 === void 0 ? void 0 : ref9.treatmentMedicine.treatmentMedicineId)
    }), pharmacies = ref22.refinedPharmacy, isDataReady = ref22.isDataReady;
    var shouldShowEmptyPharmacyMessage = function() {
        if (isNearbyPharmaciesLoading || !isDataReady) {
            return false;
        }
        if (pharmacies.length === 0) {
            return true;
        }
        return false;
    };
    var parseSelectNonBenefitMedicine = function() {
        var _medicineCode, _description, _diagnosisTypeId;
        var defaultValue = {
            id: selectedTreatmentMedicine.treatmentMedicineId,
            medicineName: selectedTreatmentMedicine.name,
            medicineCode: (_medicineCode = selectedTreatmentMedicine.medicineCode) !== null && _medicineCode !== void 0 ? _medicineCode : "",
            medicineDescription: (_description = selectedTreatmentMedicine.description) !== null && _description !== void 0 ? _description : "",
            units: [],
            treatment: {
                id: (_diagnosisTypeId = selectedTab.diagnosisTypeId) !== null && _diagnosisTypeId !== void 0 ? _diagnosisTypeId : "",
                name: selectedTab.name,
                isBenefit: false,
                categoryId: ""
            }
        };
        return new non_benefit/* NonBenefitMedicineModel */.w6(defaultValue);
    };
    var onClickViewListModeButtonWithResetSelectedPharmacy = function() {
        var ref;
        resetSelectedPharmacy();
        (ref = pharmacyListBottomSheetRef.current) === null || ref === void 0 ? void 0 : ref.clickViewListModeButton();
    };
    var selectedMedicine = parseSelectNonBenefitMedicine();
    var onClickPharmacyItem = function(selectPharmacy) {
        if (pharmacyMapInitiateError) {
            return;
        }
        setSelectedPharmacy(selectPharmacy);
    };
    var scrollToTop = function() {
        var ref;
        (ref = scrollListRef.current) === null || ref === void 0 ? void 0 : ref.scrollTo({
            top: 0
        });
    };
    var applyFilter = function(filterCriteria) {
        var ref, ref1, ref2;
        scrollToTop();
        setPharmacyFilterCriteria(filterCriteria);
        var _treatmentMedicineId, _treatmentMedicineUnitId, ref3;
        (0,utils_url/* updateSearchParams */.aM)([
            {
                key: "treatmentMedicineId",
                value: (_treatmentMedicineId = (ref = filterCriteria.selectedMedicine) === null || ref === void 0 ? void 0 : ref.treatmentMedicine.treatmentMedicineId) !== null && _treatmentMedicineId !== void 0 ? _treatmentMedicineId : ""
            },
            {
                key: "treatmentMedicineUnitId",
                value: (_treatmentMedicineUnitId = (ref1 = filterCriteria.selectedMedicine) === null || ref1 === void 0 ? void 0 : ref1.dispensationUnit.treatmentMedicineUnitId) !== null && _treatmentMedicineUnitId !== void 0 ? _treatmentMedicineUnitId : ""
            },
            {
                key: "treatmentMedicineStrengthId",
                value: (ref3 = (ref2 = filterCriteria.selectedMedicine) === null || ref2 === void 0 ? void 0 : ref2.treatmentMedicineStrengthId) !== null && ref3 !== void 0 ? ref3 : ""
            }, 
        ]);
    };
    var ref23 = (0,react.useState)({
        latitude: map/* DOCTOR_NOW_COMPANY_LATITUDE */.q,
        longitude: map/* DOCTOR_NOW_COMPANY_LONGITUDE */.y
    }), currentMapLocation = ref23[0], setCurrentMapLocation = ref23[1];
    var updateCurrentMapCoordinate = function(southWest, northEast) {
        var ref;
        searchFiltersHook.updateMapCoordinate(southWest, northEast);
        var mapCenterLatLng = (ref = mapRef.current) === null || ref === void 0 ? void 0 : ref.getCenterLatLng();
        var latitude = mapCenterLatLng === null || mapCenterLatLng === void 0 ? void 0 : mapCenterLatLng.latitude;
        var longitude = mapCenterLatLng === null || mapCenterLatLng === void 0 ? void 0 : mapCenterLatLng.longitude;
        if (!latitude || !longitude) {
            return;
        }
        setCurrentMapLocation({
            latitude: latitude,
            longitude: longitude
        });
    };
    var isSelectedAllTab = function() {
        var ref, ref1, ref2;
        // 전체 탭의 세부 정보 (서버에서 내려옴)
        var ALL_TAB_INFO = {
            name: "전체",
            diagnosisTypeId: null,
            diagnosisType: null
        };
        var isSameDiagnosisTypeWithAllTab = (pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref = pharmacyFilterCriteria.selectedTab) === null || ref === void 0 ? void 0 : ref.diagnosisType) === ALL_TAB_INFO.diagnosisType;
        var isSameDiagnosisTypeIdWithAllTab = (pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref1 = pharmacyFilterCriteria.selectedTab) === null || ref1 === void 0 ? void 0 : ref1.diagnosisTypeId) === ALL_TAB_INFO.diagnosisTypeId;
        var isSameNameWithAllTab = (pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref2 = pharmacyFilterCriteria.selectedTab) === null || ref2 === void 0 ? void 0 : ref2.name) === ALL_TAB_INFO.name;
        var ref3;
        return (ref3 = isSameDiagnosisTypeWithAllTab && isSameDiagnosisTypeIdWithAllTab && isSameNameWithAllTab) !== null && ref3 !== void 0 ? ref3 : false;
    };
    var getFavoritePharmacyClickEventName = function(isFavorite) {
        var viewType = pharmacyViewTypeHook.shouldShowListView ? "list" : "map";
        if (isFavorite) {
            return "".concat(pharmacy/* PharmacyDdAction.ClickRemoveFavoritePharmacy */.Fe.ClickRemoveFavoritePharmacy, "_find_").concat(viewType);
        }
        return "".concat(pharmacy/* PharmacyDdAction.ClickAddFavoritePharmacy */.Fe.ClickAddFavoritePharmacy, "_find_").concat(viewType);
    };
    var getCtaButtonText = function() {
        var _isIncludeDiagnosisPriceFilterSelected, ref;
        return selectedPharmacy === null || selectedPharmacy === void 0 ? void 0 : selectedPharmacy.getFindPharmacyDiagnosisActionButtonText((_isIncludeDiagnosisPriceFilterSelected = searchFiltersHook.isIncludeDiagnosisPriceFilterSelected) !== null && _isIncludeDiagnosisPriceFilterSelected !== void 0 ? _isIncludeDiagnosisPriceFilterSelected : false, (ref = selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.name) !== null && ref !== void 0 ? ref : "탈모약", isSelectedAllTab(), queries.diagnosisTypeId);
    };
    var onClickOpenAppInstallLink = function() {
        airbridgeDynamicLink.navigateWithTracking(deeplink/* DeeplinkLoggerEventName.ClickCtaButton */.l.ClickCtaButton, (0,_object_spread/* default */.Z)({
            campaign: "web_nonbenefit_map",
            content: "web_content_flt_details",
            term: getCtaButtonText(),
            sub_id: queries.diagnosisTypeId,
            sub_id_1: searchFiltersHook.selectedSortFilter.type,
            sub_id_2: selectedTreatmentMedicine.treatmentMedicineId,
            sub_id_3: String(selectedTreatmentMedicineUnit.treatmentMedicineUnitId)
        }, invitationCode && {
            invitationCode: invitationCode
        }));
    };
    var isEnabledWebDiagnosisCategory = selectedTab.diagnosisTypeId === category/* TREATMENT_CATEGORIES_IDS.Hairloss */.x5.Hairloss || selectedTab.diagnosisTypeId === category/* TREATMENT_CATEGORIES_IDS.Acne */.x5.Acne;
    var onClickCtaButton = function() {
        if (isEnabledWebDiagnosisCategory) {
            var _diagnosisTypeId, _diagnosisTypeId1;
            onClickTelemedicineRequest({
                categoryId: (_diagnosisTypeId = selectedTab.diagnosisTypeId) !== null && _diagnosisTypeId !== void 0 ? _diagnosisTypeId : "",
                type: medical_category/* EMedicalCategoryType.TREATMENT */.m1.TREATMENT,
                redirectUrl: (0,telemedicine/* getCategoryPath */.IX)((_diagnosisTypeId1 = selectedTab.diagnosisTypeId) !== null && _diagnosisTypeId1 !== void 0 ? _diagnosisTypeId1 : "", medical_category/* EMedicalCategoryType.TREATMENT */.m1.TREATMENT)
            });
            return;
        }
        onOpenAppInstallBottomSheet();
    };
    var onClickCopyInvitationCode = function() {
        if (navigator.clipboard) {
            toast({
                text: "복사가 완료되었습니다"
            });
            navigator.clipboard.writeText(invitationCode !== null && invitationCode !== void 0 ? invitationCode : "");
        }
    };
    var onOpenAppInstallBottomSheet = function() {
        pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.BottomCtaClick */.$.BottomCtaClick, {
            drug: selectedMedicine.medicineDisplayName
        });
        showModal({
            type: modal/* MODAL_TYPE.BASIC */.f.BASIC,
            props: {
                body: /*#__PURE__*/ (0,jsx_runtime.jsx)(views_non_benefit/* DiagnosisAppInstallBottomSheet */.Cx, {
                    client: client,
                    buttonId: "pharmacy-map",
                    treatmentProductMedicineName: selectedMedicine.treatmentProductMedicineName,
                    invitationCode: invitationCode,
                    onClose: closeModal,
                    qrCodeUrl: "".concat(airbrigdeLink).concat(invitationCode ? "?invitationCode=".concat(invitationCode) : ""),
                    onClickOpenAppInstallLink: onClickOpenAppInstallLink,
                    onClickCopyInvitationCode: onClickCopyInvitationCode
                })
            }
        });
    };
    var onClickTab = function(tab) {
        selectTab(tab);
        resetSelectedPharmacy();
    };
    var addFavoritePharmacy = function(pharmacy) {
        addFavoritePharmacyMutation({
            pharmacyId: pharmacy.pharmacyId
        }, {
            onSuccess: function() {
                showToast("단골 약국으로 지정했어요.\n더보기 메뉴에서 확인할 수 있어요.");
                pharmacy.updateFavoritePharmacy(true);
                // 단골 약국 캐시 업데이트
                useFavoritePharmacies/* default.updateFavoritePharmacyStatus */.Z.updateFavoritePharmacyStatus(queryClient, pharmacy.pharmacyId, true);
            },
            onError: function(error) {
                showToast(error.message);
            }
        });
    };
    var removeFavoritePharmacy = function(pharmacy) {
        removeFavoritePharmacyMutation({
            pharmacyId: pharmacy.pharmacyId
        }, {
            onSuccess: function() {
                showToast("단골 약국에서 제외했어요.");
                pharmacy.updateFavoritePharmacy(false);
                // 단골 약국 캐시 업데이트
                useFavoritePharmacies/* default.updateFavoritePharmacyStatus */.Z.updateFavoritePharmacyStatus(queryClient, pharmacy.pharmacyId, false);
            }
        });
    };
    var onClickFavoritePharmacy = function(e, pharmacy) {
        e.stopPropagation();
        if (!(client === null || client === void 0 ? void 0 : client.isWebView) && !loginViewModel.isLoggedIn) {
            openLoginModal();
            return;
        }
        if (pharmacy.isFavoritePharmacy) {
            return removeFavoritePharmacy(pharmacy);
        }
        addFavoritePharmacy(pharmacy);
    };
    var openNowPharmacyInfo = function() {
        log({
            eventName: "".concat(pharmacy/* FindPharmacyDdAction.ClickNowInfoInFind */.vy.ClickNowInfoInFind)
        });
        navigate.navigateToPureWebViewAppScreen({
            uri: url/* OutLinks.StockConfirmInfo */.s.StockConfirmInfo
        });
    };
    var onClickCurrentLocation = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                // useWebLocation을 이용한 구현
                userLocationHook.requestGeolocationPermissionInWeb(function(param) {
                    var latitude = param.latitude, longitude = param.longitude;
                    var ref;
                    if (pharmacyMapInitiateError) {
                        return;
                    }
                    (ref = mapRef.current) === null || ref === void 0 ? void 0 : ref.setCenter(latitude, longitude);
                }, true);
                return [
                    2
                ];
            });
        });
        return function onClickCurrentLocation() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (!selectedMedicine.medicineDisplayName) {
            return;
        }
        pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.PageIn */.$.PageIn, {
            drug: selectedMedicine.medicineDisplayName
        });
    }, [
        selectedMedicine.medicineDisplayName
    ]);
    var ref24;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        breadCrumbs: breadCrumbs
    }, userLocationHook, searchFiltersHook), {
        isNearbyPharmaciesLoading: isNearbyPharmaciesLoading,
        pharmacies: pharmacies,
        scrollListRef: scrollListRef,
        selectedTreatmentMedicine: selectedTreatmentMedicine,
        selectedTreatmentMedicineUnit: selectedTreatmentMedicineUnit,
        queries: queries,
        selectedMedicine: selectedMedicine,
        currentMapLocation: currentMapLocation,
        selectedPharmacy: selectedPharmacy,
        mapRef: mapRef,
        pharmacyListBottomSheetRef: pharmacyListBottomSheetRef,
        tabs: tabs,
        selectedTab: selectedTab,
        selectedTabName: (ref24 = selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.name) !== null && ref24 !== void 0 ? ref24 : "탈모약",
        shouldShowPharmacyCard: shouldShowPharmacyCard,
        selectTab: selectTab,
        onClickTab: onClickTab,
        shouldShowEmptyPharmacyMessage: shouldShowEmptyPharmacyMessage,
        updateCurrentMapCoordinate: updateCurrentMapCoordinate,
        applyFilter: applyFilter,
        updateSelectedPharmacy: updateSelectedPharmacy,
        resetSelectedPharmacy: resetSelectedPharmacy,
        updatePharmacyMapInitiateError: updatePharmacyMapInitiateError,
        onClickPharmacyItem: onClickPharmacyItem,
        isSelectedAllTab: isSelectedAllTab,
        onClickCtaButton: onClickCtaButton,
        getFavoritePharmacyClickEventName: getFavoritePharmacyClickEventName,
        onClickViewListModeButtonWithResetSelectedPharmacy: onClickViewListModeButtonWithResetSelectedPharmacy,
        openNowPharmacyInfo: openNowPharmacyInfo,
        onClickFavoritePharmacy: onClickFavoritePharmacy,
        openLoginModal: openLoginModal,
        closeLoginModal: closeLoginModal,
        showLoginModal: showLoginModal,
        onClickCurrentLocation: onClickCurrentLocation,
        isVisibleMedicinePrice: isVisibleMedicinePrice,
        getCtaButtonText: getCtaButtonText,
        isEnabledWebDiagnosisCategory: isEnabledWebDiagnosisCategory
    });
};
/* harmony default export */ var non_benefit_useNonBenefitMapViewModel = (useNonBenefitMapViewModel);

;// CONCATENATED MODULE: ./src/pages/non-benefit/map/index.tsx
// PageDescription: 비급여 가격 지도 페이지







var NonBenefitMapPages = function(param) {
    var client = param.client;
    var viewModel = non_benefit_useNonBenefitMapViewModel(client);
    var _queries = viewModel.queries, treatmentMedicineId = _queries.treatmentMedicineId, diagnosisTypeId = _queries.diagnosisTypeId, treatmentMedicineUnitId = _queries.treatmentMedicineUnitId, treatmentMedicineStrengthId = _queries.treatmentMedicineStrengthId;
    var selectedMedicine = viewModel.selectedMedicine;
    var ref;
    var title = "".concat((ref = selectedMedicine === null || selectedMedicine === void 0 ? void 0 : selectedMedicine.treatmentMedicineSeoTitle) !== null && ref !== void 0 ? ref : "");
    var ref1;
    var description = "".concat((ref1 = selectedMedicine === null || selectedMedicine === void 0 ? void 0 : selectedMedicine.treatmentMedicineSeoDescription) !== null && ref1 !== void 0 ? ref1 : "");
    var canonical = "".concat("https://doctornow.co.kr").concat(common/* ROUTES.NON_BENEFIT.MAP.path */.Z6.NON_BENEFIT.MAP.path).concat((0,utils_url/* addQueryString */.sC)({
        diagnosisTypeId: diagnosisTypeId,
        treatmentMedicineId: treatmentMedicineId,
        treatmentMedicineUnitId: treatmentMedicineUnitId,
        treatmentMedicineStrengthId: treatmentMedicineStrengthId
    }));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: title,
                description: description,
                openGraph: {
                    title: title,
                    description: description,
                    url: canonical,
                    images: [
                        {
                            url: "".concat("https://media.doctornow.co.kr/og-main.png"),
                            alt: "Og Image Alt"
                        }, 
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(map_NonBenefitMapTemplate, {
                client: client,
                viewModel: viewModel,
                title: "".concat(selectedMedicine === null || selectedMedicine === void 0 ? void 0 : selectedMedicine.treatmentProductMedicineName, " 최저가 약국 찾기")
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var non_benefit_map = (NonBenefitMapPages);


/***/ }),

/***/ 36794:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CopyToClipboard = void 0;

var _react = _interopRequireDefault(__webpack_require__(2784));

var _copyToClipboard = _interopRequireDefault(__webpack_require__(50381));

var _excluded = ["text", "onCopy", "options", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CopyToClipboard = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(CopyToClipboard, _React$PureComponent);

  var _super = _createSuper(CopyToClipboard);

  function CopyToClipboard() {
    var _this;

    _classCallCheck(this, CopyToClipboard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
      var _this$props = _this.props,
          text = _this$props.text,
          onCopy = _this$props.onCopy,
          children = _this$props.children,
          options = _this$props.options;

      var elem = _react["default"].Children.only(children);

      var result = (0, _copyToClipboard["default"])(text, options);

      if (onCopy) {
        onCopy(text, result);
      } // Bypass onClick if it was present


      if (elem && elem.props && typeof elem.props.onClick === 'function') {
        elem.props.onClick(event);
      }
    });

    return _this;
  }

  _createClass(CopyToClipboard, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _text = _this$props2.text,
          _onCopy = _this$props2.onCopy,
          _options = _this$props2.options,
          children = _this$props2.children,
          props = _objectWithoutProperties(_this$props2, _excluded);

      var elem = _react["default"].Children.only(children);

      return /*#__PURE__*/_react["default"].cloneElement(elem, _objectSpread(_objectSpread({}, props), {}, {
        onClick: this.onClick
      }));
    }
  }]);

  return CopyToClipboard;
}(_react["default"].PureComponent);

exports.CopyToClipboard = CopyToClipboard;

_defineProperty(CopyToClipboard, "defaultProps", {
  onCopy: undefined,
  options: undefined
});

/***/ }),

/***/ 72282:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(36794),
    CopyToClipboard = _require.CopyToClipboard;

CopyToClipboard.CopyToClipboard = CopyToClipboard;
module.exports = CopyToClipboard;

/***/ }),

/***/ 91706:
/***/ (function(module) {


module.exports = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2182,1498,9040,1579,2564,9653,1743,4365,7292,5679,2149,1950,4429,5179,5203,9922,9466,6409,5514,7417,6874,635,8185,2367,2856,7006,3650,1343,1986,9774,2888,179], function() { return __webpack_exec__(19494); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);